var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5MentalDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87848",
    "data-name": "Group 87848",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 463,
    height: 412.783,
    viewBox: "0 0 463 412.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25426",
    "data-name": "Rectangle 25426",
    width: 463,
    height: 412.784,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25371",
    "data-name": "Rectangle 25371",
    width: 7.843,
    height: 6.794,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25373",
    "data-name": "Rectangle 25373",
    width: 3.924,
    height: 9.059,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25374",
    "data-name": "Rectangle 25374",
    width: 56.763,
    height: 39.978,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25376",
    "data-name": "Rectangle 25376",
    width: 3.924,
    height: 9.487,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25377",
    "data-name": "Rectangle 25377",
    width: 56.764,
    height: 91.64,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25378",
    "data-name": "Rectangle 25378",
    width: 51.063,
    height: 88.366,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25379",
    "data-name": "Rectangle 25379",
    width: 107.826,
    height: 62.239,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25380",
    "data-name": "Rectangle 25380",
    width: 43.22,
    height: 56.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25381",
    "data-name": "Rectangle 25381",
    width: 43.22,
    height: 40.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25382",
    "data-name": "Rectangle 25382",
    width: 27.273,
    height: 31.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25383",
    "data-name": "Rectangle 25383",
    width: 43.22,
    height: 38.543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25384",
    "data-name": "Rectangle 25384",
    width: 24.533,
    height: 14.164,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25385",
    "data-name": "Rectangle 25385",
    width: 15.177,
    height: 22.534,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25386",
    "data-name": "Rectangle 25386",
    width: 13.198,
    height: 22.53,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25387",
    "data-name": "Rectangle 25387",
    width: 16.088,
    height: 22.116,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25388",
    "data-name": "Rectangle 25388",
    width: 234.054,
    height: 201.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25389",
    "data-name": "Rectangle 25389",
    width: 65.7,
    height: 60.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25390",
    "data-name": "Rectangle 25390",
    width: 229.901,
    height: 178.851,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25391",
    "data-name": "Rectangle 25391",
    width: 105.359,
    height: 106.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25392",
    "data-name": "Rectangle 25392",
    width: 16.577,
    height: 15.358,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25393",
    "data-name": "Rectangle 25393",
    width: 19.869,
    height: 10.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25394",
    "data-name": "Rectangle 25394",
    width: 19.869,
    height: 10.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25396",
    "data-name": "Rectangle 25396",
    width: 19.871,
    height: 10.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25397",
    "data-name": "Rectangle 25397",
    width: 19.87,
    height: 10.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25401",
    "data-name": "Rectangle 25401",
    width: 16.575,
    height: 15.358,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25402",
    "data-name": "Rectangle 25402",
    width: 197.246,
    height: 166.825,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25403",
    "data-name": "Rectangle 25403",
    width: 34.088,
    height: 33.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25404",
    "data-name": "Rectangle 25404",
    width: 23.344,
    height: 42.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25405",
    "data-name": "Rectangle 25405",
    width: 106.628,
    height: 111.734,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25406",
    "data-name": "Rectangle 25406",
    width: 47.359,
    height: 62.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25407",
    "data-name": "Rectangle 25407",
    width: 36.19,
    height: 56.193,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25408",
    "data-name": "Rectangle 25408",
    width: 8.509,
    height: 3.959,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25409",
    "data-name": "Rectangle 25409",
    width: 55.508,
    height: 74.992,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25410",
    "data-name": "Rectangle 25410",
    width: 21.386,
    height: 9.417,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25411",
    "data-name": "Rectangle 25411",
    width: 27.575,
    height: 16.531,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25412",
    "data-name": "Rectangle 25412",
    width: 2.845,
    height: 3.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25413",
    "data-name": "Rectangle 25413",
    width: 34.315,
    height: 44.565,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25414",
    "data-name": "Rectangle 25414",
    width: 7.708,
    height: 31.907,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25415",
    "data-name": "Rectangle 25415",
    width: 7.059,
    height: 2.285,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25416",
    "data-name": "Rectangle 25416",
    width: 1.202,
    height: 1.566,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25423",
    "data-name": "Rectangle 25423",
    width: 24.154,
    height: 73.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25424",
    "data-name": "Rectangle 25424",
    width: 10.504,
    height: 4.245,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87667",
    "data-name": "Group 87667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87666",
    "data-name": "Group 87666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87665",
    "data-name": "Group 87665",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275861",
    "data-name": "Path 275861",
    d: "M156.7,215.92l149.692-86.426c4.552-2.628,4.552-6.885,0-9.513L245.581,84.872c-4.549-2.628-11.927-2.628-16.478,0L79.411,171.3c-4.549,2.625-4.549,6.885,0,9.513l60.811,35.109c4.552,2.628,11.929,2.628,16.478,0",
    transform: "translate(133.142 145.233)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275862",
    "data-name": "Path 275862",
    d: "M194.442,184.146,147.91,152.868l30.651-17.7c4.552-2.625,4.552-6.885,0-9.511L117.749,90.545c-4.549-2.625-11.927-2.625-16.478,0l-87.86,50.728c-4.552,2.628-4.552,6.885,0,9.513L74.222,185.9c4.549,2.628,11.927,2.628,16.476,0l16.987-9.808,54.482,28.144c9.337,4.824,23.826,4.739,32.362-.19s8.5-13.837-.088-19.9",
    transform: "translate(17.515 155.176)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275863",
    "data-name": "Path 275863",
    d: "M167.4,112.276l-57.88-33.4a9.083,9.083,0,0,0-8.234.011L53.186,106.8c-2.273,1.318-2.27,3.451.006,4.763l57.88,33.4a9.083,9.083,0,0,0,8.234-.011l48.1-27.912c2.273-1.321,2.27-3.454-.006-4.766",
    transform: "translate(90.193 136.459)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275864",
    "data-name": "Path 275864",
    d: "M15.158,37.621l1.632.944L57.609,15l-1.632-.944Z",
    transform: "translate(26.555 24.621)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275865",
    "data-name": "Path 275865",
    d: "M54.936,35.676,15.752,58.3V24.336L54.936,1.712Z",
    transform: "translate(27.595 3)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275866",
    "data-name": "Path 275866",
    d: "M59.241.342,15.158,25.794V65.413L59.243,39.961ZM57.609,39.02,16.793,62.587V26.738L57.609,3.171Z",
    transform: "translate(26.555 0.599)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275867",
    "data-name": "Path 275867",
    d: "M31.623,37.219l-1.632-.944V2.314l1.632-.944Z",
    transform: "translate(52.541 2.4)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275868",
    "data-name": "Path 275868",
    d: "M60.281.943,58.65,0,14.564,25.452,16.2,26.4Z",
    transform: "translate(25.515 -0.001)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275869",
    "data-name": "Path 275869",
    d: "M14.565,9.249l1.632.944V49.812l-1.632-.944Z",
    transform: "translate(25.516 16.203)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275870",
    "data-name": "Path 275870",
    d: "M28.952,12.219c1.522-.878,2.755-.165,2.755,1.591a6.09,6.09,0,0,1-2.755,4.775c-1.522.878-2.755.165-2.755-1.591a6.09,6.09,0,0,1,2.755-4.775",
    transform: "translate(45.894 20.748)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275871",
    "data-name": "Path 275871",
    d: "M19.771,17.1,40.52,5.106c.578-.333,1.046-.063,1.046.6v.061A2.314,2.314,0,0,1,40.52,7.58l-20.749,12c-.578.336-1.046.066-1.046-.6v-.069A2.31,2.31,0,0,1,19.771,17.1",
    transform: "translate(32.804 8.695)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275872",
    "data-name": "Path 275872",
    d: "M18.583,22.954,45.9,7.185c.575-.333,1.043-.182,1.043.338A2.091,2.091,0,0,1,45.9,9.071L18.564,24.85c-.578.333-1.04.179-1.035-.344a2.123,2.123,0,0,1,1.054-1.552",
    transform: "translate(30.709 12.279)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275873",
    "data-name": "Path 275873",
    d: "M18.583,24.323,45.9,8.554c.575-.333,1.043-.182,1.043.338A2.091,2.091,0,0,1,45.9,10.44L18.564,26.219c-.578.333-1.04.179-1.035-.344a2.123,2.123,0,0,1,1.054-1.552",
    transform: "translate(30.709 14.677)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275874",
    "data-name": "Path 275874",
    d: "M18.583,25.692,45.9,9.923c.575-.333,1.043-.182,1.043.338A2.091,2.091,0,0,1,45.9,11.809L18.564,27.588c-.578.333-1.04.179-1.035-.344a2.123,2.123,0,0,1,1.054-1.552",
    transform: "translate(30.709 17.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275875",
    "data-name": "Path 275875",
    d: "M37.815,15.639a1.518,1.518,0,0,1-.682.179c-.583.008-.528-.594-.512-1,.008-.184-.25-.468-.385-.226-.352.638-.8,1.23-1.183,1.855-.231.38-.674,1.238-1.236,1.117-.234-.052-.311-.3-.311-.614a3.071,3.071,0,0,0,.366-1.7c-.019-.179-.322-.4-.416-.154a5.471,5.471,0,0,0-.355,1.566,9.606,9.606,0,0,1-.881,1.315c-.19.25-.358.531-.567.771-.05.055-.146.2-.228.215-.193.033-.173-.083-.2-.209a1.379,1.379,0,0,1,.094-.561v0l.014-.044-.011-.006c0-.187-.234-.46-.333-.228a8.29,8.29,0,0,1-1.6,2.669c-.036.033-.072.061-.107.088-.006-.107-.03-.22-.039-.327a2.964,2.964,0,0,0-.129-.743c-.047-.118-.256-.3-.366-.143a12.768,12.768,0,0,1-1.816,2.512,3.021,3.021,0,0,1-.383.267c-.124-.072.069-.732.094-.834.074-.3.173-.586.27-.878a3.193,3.193,0,0,0,.217-.724c.039-.223-.349-.57-.421-.267-.028.124-.135.424-.25.793a19.475,19.475,0,0,1-1.533,2.6,5.989,5.989,0,0,1-2.133,2.056c-.245.129-.7.319-.963.129-.22-.16-.239-.528-.25-.773a6.666,6.666,0,0,1,.256-1.891,11.451,11.451,0,0,0,2.369-1.67,8.131,8.131,0,0,0,1.789-1.984c.245-.438.388-1.159-.2-1.409-.4-.171-.93.113-1.277.305a5.656,5.656,0,0,0-1.3,1.013,7.466,7.466,0,0,0-1.629,2.978c-.052.171-.118.394-.187.649a5.042,5.042,0,0,1-3.005.5c-.055-.008-.08.118-.025.129a4.935,4.935,0,0,0,2.945-.281c-.264,1.142-.413,2.653.652,2.947,1.134.311,2.347-1.037,2.917-1.8a12.217,12.217,0,0,0,1.142-1.844.944.944,0,0,1,.1-.135c-.033.528.1.914.622.828.545-.094,1-.837,1.293-1.238.275-.383.523-.782.776-1.175.047.476.132,1.018.589.927.438-.088.831-.883,1.046-1.205a9.687,9.687,0,0,0,.517-.856.612.612,0,0,0,.1.157c.38.407.828-.028,1.073-.349.347-.457.738-.938,1.065-1.453a.875.875,0,0,0,.451.509c.583.275,1.131-.206,1.47-.638a12.575,12.575,0,0,0,1.1-1.767.814.814,0,0,0,.4.559A1.341,1.341,0,0,0,38,16.043c.179-.11.006-.5-.187-.4M25.035,17.92c.272-.138.837-.369.867.088a1.539,1.539,0,0,1-.372.8,9.925,9.925,0,0,1-1.588,1.69,12.7,12.7,0,0,1-1.99,1.514,6.417,6.417,0,0,1,3.082-4.089",
    transform: "translate(32.128 25.392)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275876",
    "data-name": "Path 275876",
    d: "M38.538,37.621l1.632.944L80.989,15l-1.632-.944Z",
    transform: "translate(67.514 24.621)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275877",
    "data-name": "Path 275877",
    d: "M78.316,35.676,39.132,58.3V24.336L78.316,1.712Z",
    transform: "translate(68.554 3)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275878",
    "data-name": "Path 275878",
    d: "M82.621.342,38.538,25.794V65.413L82.623,39.961ZM80.989,39.02,40.173,62.587V26.738L80.989,3.171Z",
    transform: "translate(67.514 0.599)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275879",
    "data-name": "Path 275879",
    d: "M55,37.219l-1.632-.944V2.314L55,1.37Z",
    transform: "translate(93.5 2.4)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275880",
    "data-name": "Path 275880",
    d: "M83.661.943,82.029,0,37.944,25.452l1.635.944Z",
    transform: "translate(66.474 -0.001)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275881",
    "data-name": "Path 275881",
    d: "M37.945,9.249l1.632.944V49.812l-1.632-.944Z",
    transform: "translate(66.475 16.203)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275882",
    "data-name": "Path 275882",
    d: "M52.332,12.219c1.522-.878,2.755-.165,2.755,1.591a6.09,6.09,0,0,1-2.755,4.775c-1.522.878-2.755.165-2.755-1.591a6.09,6.09,0,0,1,2.755-4.775",
    transform: "translate(86.853 20.748)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275883",
    "data-name": "Path 275883",
    d: "M43.151,17.1,63.9,5.106c.578-.333,1.046-.063,1.046.6v.061A2.315,2.315,0,0,1,63.9,7.58l-20.749,12c-.578.336-1.046.066-1.046-.6v-.069A2.31,2.31,0,0,1,43.151,17.1",
    transform: "translate(73.763 8.695)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275884",
    "data-name": "Path 275884",
    d: "M41.965,22.954,69.274,7.185c.575-.333,1.043-.182,1.043.338a2.091,2.091,0,0,1-1.043,1.547L41.943,24.85c-.578.333-1.04.179-1.035-.344a2.119,2.119,0,0,1,1.057-1.552",
    transform: "translate(71.666 12.279)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275885",
    "data-name": "Path 275885",
    d: "M41.965,24.323,69.274,8.554c.575-.333,1.043-.182,1.043.338a2.091,2.091,0,0,1-1.043,1.547L41.943,26.219c-.578.333-1.04.179-1.035-.344a2.119,2.119,0,0,1,1.057-1.552",
    transform: "translate(71.666 14.677)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275886",
    "data-name": "Path 275886",
    d: "M41.965,25.692,69.274,9.923c.575-.333,1.043-.182,1.043.338a2.091,2.091,0,0,1-1.043,1.547L41.943,27.588c-.578.333-1.04.179-1.035-.344a2.119,2.119,0,0,1,1.057-1.552",
    transform: "translate(71.666 17.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275887",
    "data-name": "Path 275887",
    d: "M61.195,15.639a1.518,1.518,0,0,1-.682.179c-.583.008-.528-.594-.512-1,.008-.184-.25-.468-.385-.226-.352.638-.8,1.23-1.183,1.855-.231.38-.674,1.238-1.236,1.117-.234-.052-.311-.3-.311-.614a3.071,3.071,0,0,0,.366-1.7c-.019-.179-.322-.4-.416-.154a5.471,5.471,0,0,0-.355,1.566A9.607,9.607,0,0,1,55.6,17.97c-.19.25-.358.531-.567.771-.05.055-.146.2-.228.215-.193.033-.173-.083-.2-.209a1.378,1.378,0,0,1,.094-.561v0l.014-.044-.011-.006c0-.187-.234-.46-.333-.228a8.291,8.291,0,0,1-1.6,2.669c-.036.033-.072.061-.107.088-.005-.107-.03-.22-.039-.327a2.962,2.962,0,0,0-.129-.743c-.047-.118-.256-.3-.366-.143a12.767,12.767,0,0,1-1.816,2.512,3.021,3.021,0,0,1-.383.267c-.124-.072.069-.732.094-.834.074-.3.173-.586.27-.878a3.191,3.191,0,0,0,.217-.724c.039-.223-.349-.57-.421-.267-.028.124-.135.424-.25.793a19.473,19.473,0,0,1-1.533,2.6,5.989,5.989,0,0,1-2.133,2.056c-.245.129-.7.319-.963.129-.22-.16-.239-.528-.25-.773a6.666,6.666,0,0,1,.256-1.891,11.451,11.451,0,0,0,2.369-1.67,8.131,8.131,0,0,0,1.789-1.984c.245-.438.388-1.159-.2-1.409-.4-.171-.933.113-1.277.305a5.656,5.656,0,0,0-1.3,1.013,7.466,7.466,0,0,0-1.629,2.978c-.052.171-.118.394-.187.649a5.042,5.042,0,0,1-3.005.5c-.055-.008-.08.118-.025.129a4.935,4.935,0,0,0,2.945-.281c-.264,1.142-.413,2.653.652,2.947,1.134.311,2.347-1.037,2.917-1.8a12.218,12.218,0,0,0,1.142-1.844.943.943,0,0,1,.1-.135c-.033.528.1.914.622.828.545-.094,1-.837,1.293-1.238.275-.383.523-.782.776-1.175.047.476.132,1.018.589.927.438-.088.831-.883,1.046-1.205a9.687,9.687,0,0,0,.517-.856.611.611,0,0,0,.1.157c.38.407.828-.028,1.073-.349.347-.457.737-.938,1.065-1.453a.875.875,0,0,0,.451.509c.583.275,1.131-.206,1.47-.638a12.575,12.575,0,0,0,1.1-1.767.814.814,0,0,0,.4.559,1.34,1.34,0,0,0,1.373-.088c.179-.11.006-.5-.187-.4M48.415,17.92c.272-.138.837-.369.867.088a1.539,1.539,0,0,1-.371.8,9.924,9.924,0,0,1-1.588,1.69,12.7,12.7,0,0,1-1.99,1.514,6.417,6.417,0,0,1,3.082-4.089",
    transform: "translate(73.087 25.392)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275888",
    "data-name": "Path 275888",
    d: "M122.442,22.231V18.238h0a1.357,1.357,0,0,1,.8-1.065L147.374,3.325a4.115,4.115,0,0,1,3.71,0l69.37,39.809a1.371,1.371,0,0,1,.8,1.065h0v3.993h0a1.367,1.367,0,0,1-.8,1.065L196.322,63.1a4.115,4.115,0,0,1-3.71,0L123.243,23.3a1.361,1.361,0,0,1-.8-1.065Z",
    transform: "translate(214.505 5.052)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275889",
    "data-name": "Path 275889",
    d: "M220.432,45.264,196.3,59.111a4.115,4.115,0,0,1-3.71,0L123.222,19.3a1.122,1.122,0,0,1,0-2.13L147.353,3.325a4.115,4.115,0,0,1,3.71,0l69.37,39.809a1.122,1.122,0,0,1,0,2.13",
    transform: "translate(214.526 5.052)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275890",
    "data-name": "Path 275890",
    d: "M148.616,33.54v3.993a3.82,3.82,0,0,0,1.849-.443L174.6,23.245a1.357,1.357,0,0,0,.8-1.065h.008V18.187H175.4a1,1,0,0,0-.151-.454c.278.515.069,1.106-.647,1.516L150.465,33.1a3.737,3.737,0,0,1-1.849.443",
    transform: "translate(260.359 31.066)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275891",
    "data-name": "Path 275891",
    d: "M178.423,23.544,157.979,35.2,124.2,15.817,144.646,4.16Z",
    transform: "translate(217.589 7.287)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275892",
    "data-name": "Path 275892",
    d: "M136.412,25.578l19.723-11.319a8.156,8.156,0,0,1,.1-5.113l-19.593,11.2a19.306,19.306,0,0,0-.234,5.234",
    transform: "translate(238.921 16.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275893",
    "data-name": "Path 275893",
    d: "M138.049,19.734a4.161,4.161,0,0,0-1.9,3.264v3.809c0,1.2.85,1.69,1.9,1.09L157.486,16.74l0-.944L138.31,26.732c-.627.36-1.137.069-1.137-.652l.019-3.533a2.5,2.5,0,0,1,1.137-1.957L157.486,9.649V8.581Z",
    transform: "translate(238.525 15.033)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275894",
    "data-name": "Path 275894",
    d: "M178.985,20.922,145.211,1.538,125.774,12.691a4.162,4.162,0,0,0-1.893,3.264v3.811a1.322,1.322,0,0,0,.553,1.219l33.777,19.382a1.319,1.319,0,0,1-.556-1.216l0-3.814a4.158,4.158,0,0,1,1.893-3.264Z",
    transform: "translate(217.026 2.694)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275895",
    "data-name": "Path 275895",
    d: "M158.207,25.484a3.823,3.823,0,0,0-.556,1.855l0,3.814a1.327,1.327,0,0,0,.556,1.219L124.436,12.99a1.324,1.324,0,0,1-.556-1.219V7.96a3.833,3.833,0,0,1,.556-1.858Z",
    transform: "translate(217.024 10.69)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275896",
    "data-name": "Path 275896",
    d: "M166.2.663l.19,2.581L143.561,15.487l-.515-1.5Z",
    transform: "translate(250.602 1.161)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275897",
    "data-name": "Path 275897",
    d: "M143.157,13.847,165.266,1.083,169.113,3.3l-22.546,13.19Z",
    transform: "translate(250.796 1.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275898",
    "data-name": "Path 275898",
    d: "M153.622,6.186l2.185,25.62a1.809,1.809,0,0,1-.817,1.42l-12.827,7.425a1.594,1.594,0,0,1-.663.19l7.969-32.453a1.618,1.618,0,0,0,.666-.187l.925-.537Z",
    transform: "translate(247.892 10.837)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275899",
    "data-name": "Path 275899",
    d: "M151.8,9.528l-2.287-1.959L147.833,6.13c-.171-.272-.372-.476-.264-.7L139.7,37.647l-.011.028c-.113.226-.14.732.168.908l3.965,3.4a1.75,1.75,0,0,0,.977.19l7.969-32.453a1.758,1.758,0,0,1-.974-.187",
    transform: "translate(244.589 9.509)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275900",
    "data-name": "Path 275900",
    d: "M142.792,13.935c-.454.261-.341.553,0,.947l3.966,3.4a1.813,1.813,0,0,0,1.64,0l3.487-2.012c.454-.261.534-.641.179-.845a1.639,1.639,0,0,0-1.458.1l-2.752,1.588a.6.6,0,0,1-.548,0l-2.9-2.515a.167.167,0,0,1,0-.316L167.168,1.064l-1.09-.63Z",
    transform: "translate(249.63 0.76)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275901",
    "data-name": "Path 275901",
    d: "M167.7,1.113,145.95,13.678V55.053L167.7,42.49Z",
    transform: "translate(255.688 1.949)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275902",
    "data-name": "Path 275902",
    d: "M146.2,13.619,167.253,1.538a8.842,8.842,0,0,0,4.813,2.634L151.2,16.2s-1.348-.314-4.992-2.579",
    transform: "translate(256.133 2.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275903",
    "data-name": "Path 275903",
    d: "M154.118,17.191a4.494,4.494,0,0,1-4.045,0l-3.544-2.034a1.224,1.224,0,0,1,0-2.323L167.275.93l.878.5-20.4,11.784a.734.734,0,0,0,0,1.392l3.294,1.869a2.7,2.7,0,0,0,2.427,0l20.4-11.762.993.572Z",
    transform: "translate(255.234 1.629)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275904",
    "data-name": "Path 275904",
    d: "M174.861,2.513V43.89L154.117,55.8a4.511,4.511,0,0,1-4.045,0l-3.544-2.034a1.418,1.418,0,0,1-.837-1.161V11.223a1.414,1.414,0,0,0,.837,1.161l3.544,2.036a4.494,4.494,0,0,0,4.045,0Z",
    transform: "translate(255.235 4.403)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275905",
    "data-name": "Path 275905",
    d: "M152.095,9.357a4.139,4.139,0,0,1-2.023-.482l-3.544-2.036a1.418,1.418,0,0,1-.837-1.161V47.055a1.411,1.411,0,0,0,.837,1.159l3.544,2.034a4.139,4.139,0,0,0,2.023.482Z",
    transform: "translate(255.235 9.947)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275906",
    "data-name": "Path 275906",
    d: "M94.508,96.948l-7.843-4.53,7.843-2.265Z",
    transform: "translate(151.827 157.939)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87505",
    "data-name": "Group 87505",
    transform: "translate(238.491 248.092)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87504",
    "data-name": "Group 87504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87503",
    "data-name": "Group 87503",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275907",
    "data-name": "Path 275907",
    d: "M94.508,96.948l-7.843-4.53,7.843-2.265Z",
    transform: "translate(-86.664 -90.154)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87508",
    "data-name": "Group 87508",
    transform: "translate(238.491 248.092)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87507",
    "data-name": "Group 87507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87506",
    "data-name": "Group 87506",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275908",
    "data-name": "Path 275908",
    d: "M94.508,96.948l-7.843-4.53,7.843-2.265Z",
    transform: "translate(-86.664 -90.154)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275909",
    "data-name": "Path 275909",
    d: "M89.515,98.39l3.924-2.265V89.33L89.515,91.6Z",
    transform: "translate(156.82 156.497)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87511",
    "data-name": "Group 87511",
    transform: "translate(246.335 245.828)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87510",
    "data-name": "Group 87510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87509",
    "data-name": "Group 87509",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275910",
    "data-name": "Path 275910",
    d: "M89.515,98.39l3.924-2.265V89.33L89.515,91.6Z",
    transform: "translate(-89.515 -89.331)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275911",
    "data-name": "Path 275911",
    d: "M111.372,119.251v7.221L54.609,93.716V86.5Z",
    transform: "translate(95.668 151.53)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87514",
    "data-name": "Group 87514",
    transform: "translate(150.277 238.026)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87513",
    "data-name": "Group 87513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87512",
    "data-name": "Group 87512",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275912",
    "data-name": "Path 275912",
    d: "M111.372,119.251v7.221L54.609,93.716V86.5Z",
    transform: "translate(-54.609 -86.496)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87517",
    "data-name": "Group 87517",
    transform: "translate(150.277 238.026)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87516",
    "data-name": "Group 87516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87515",
    "data-name": "Group 87515",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275913",
    "data-name": "Path 275913",
    d: "M111.372,119.251v7.221L54.609,93.716V86.5Z",
    transform: "translate(-54.609 -86.496)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275914",
    "data-name": "Path 275914",
    d: "M75.236,107.062,79.16,104.8V97.576l-3.924,2.265Z",
    transform: "translate(131.804 170.942)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87520",
    "data-name": "Group 87520",
    transform: "translate(207.04 268.517)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87519",
    "data-name": "Group 87519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87518",
    "data-name": "Group 87518",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275915",
    "data-name": "Path 275915",
    d: "M75.236,107.062,79.16,104.8V97.576l-3.924,2.265Z",
    transform: "translate(-75.236 -97.575)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275916",
    "data-name": "Path 275916",
    d: "M53.183,65.921l56.763,32.756v58.885L53.183,124.8Z",
    transform: "translate(93.171 115.486)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87523",
    "data-name": "Group 87523",
    transform: "translate(146.355 181.407)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87522",
    "data-name": "Group 87522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87521",
    "data-name": "Group 87521",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275917",
    "data-name": "Path 275917",
    d: "M53.183,65.921l56.763,32.756v58.885L53.183,124.8Z",
    transform: "translate(-53.183 -65.921)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275918",
    "data-name": "Path 275918",
    d: "M73.81,96.594,124.874,67.11v58.885L73.81,155.476Z",
    transform: "translate(129.308 117.569)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87526",
    "data-name": "Group 87526",
    transform: "translate(203.118 184.68)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87525",
    "data-name": "Group 87525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87524",
    "data-name": "Group 87524",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275919",
    "data-name": "Path 275919",
    d: "M73.81,96.594,124.874,67.11v58.885L73.81,155.476Z",
    transform: "translate(-73.81 -67.111)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275920",
    "data-name": "Path 275920",
    d: "M161.01,87.963,104.247,55.207,53.183,84.691l56.763,32.756Z",
    transform: "translate(93.171 96.717)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87529",
    "data-name": "Group 87529",
    transform: "translate(146.355 151.924)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87528",
    "data-name": "Group 87528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87527",
    "data-name": "Group 87527",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275921",
    "data-name": "Path 275921",
    d: "M161.01,87.963,104.247,55.207,53.183,84.691l56.763,32.756Z",
    transform: "translate(-53.184 -55.207)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275922",
    "data-name": "Path 275922",
    d: "M75.236,101.117l43.218-24.954V107.87L75.236,132.824Z",
    transform: "translate(131.804 133.429)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87532",
    "data-name": "Group 87532",
    transform: "translate(207.04 209.591)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87531",
    "data-name": "Group 87531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87530",
    "data-name": "Group 87530",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275923",
    "data-name": "Path 275923",
    d: "M75.236,101.117l43.218-24.954V107.87L75.236,132.824Z",
    transform: "translate(-75.236 -76.163)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87535",
    "data-name": "Group 87535",
    transform: "translate(207.04 225.338)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87534",
    "data-name": "Group 87534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87533",
    "data-name": "Group 87533",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275924",
    "data-name": "Path 275924",
    d: "M118.454,97.846,91.183,81.885,75.236,91.092V122.8Z",
    transform: "translate(-75.235 -81.885)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87538",
    "data-name": "Group 87538",
    transform: "translate(222.987 209.591)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87537",
    "data-name": "Group 87537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87536",
    "data-name": "Group 87536",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275925",
    "data-name": "Path 275925",
    d: "M108.3,107.87,81.031,91.909,108.3,76.163Z",
    transform: "translate(-81.03 -76.163)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275926",
    "data-name": "Path 275926",
    d: "M75.236,94.533l43.218-24.954V83.168L75.236,108.122Z",
    transform: "translate(131.804 121.895)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87541",
    "data-name": "Group 87541",
    transform: "translate(207.04 191.473)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87540",
    "data-name": "Group 87540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87539",
    "data-name": "Group 87539",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275927",
    "data-name": "Path 275927",
    d: "M75.236,94.533l43.218-24.954V83.168L75.236,108.122Z",
    transform: "translate(-75.236 -69.579)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275928",
    "data-name": "Path 275928",
    d: "M80.1,83.364c0,.625,1.871.052,4.18-1.282l7.328-4.23c2.309-1.332,4.183-2.92,4.183-3.547V73.174L80.1,82.23v1.134",
    transform: "translate(140.332 128.193)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87544",
    "data-name": "Group 87544",
    transform: "translate(185.977 172.032)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87543",
    "data-name": "Group 87543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87542",
    "data-name": "Group 87542",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275929",
    "data-name": "Path 275929",
    d: "M88.522,64.588c4.791,2.766,4.791,7.248,0,10.017s-12.557,2.766-17.348,0-4.791-7.251,0-10.017,12.557-2.766,17.348,0",
    transform: "translate(-67.582 -62.514)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275930",
    "data-name": "Path 275930",
    d: "M86.525,76.014c3.869-3.946,6.142-13.8,2.367-16.935h-19.2c-3.773,3.129-1.5,12.983,2.364,16.932.033.036.072.072.1.107s.088.091.135.132c.107.1.223.209.349.311l.091.074c.1.074.19.149.292.217.165.116.333.226.5.322a12.732,12.732,0,0,0,11.525,0,5.569,5.569,0,0,0,.5-.325c.1-.063.182-.132.272-.2l.113-.088c.121-.1.231-.2.338-.3.052-.05.1-.1.154-.151.028-.03.061-.063.088-.094",
    transform: "translate(118.711 103.5)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275931",
    "data-name": "Path 275931",
    d: "M71.162,59.828c-4.381,2.529-4.381,6.629,0,9.158a17.535,17.535,0,0,0,15.865,0c4.378-2.529,4.378-6.629,0-9.158a17.535,17.535,0,0,0-15.865,0",
    transform: "translate(118.911 101.49)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275932",
    "data-name": "Path 275932",
    d: "M71.471,60.007c-2.664,1.538-2.664,4.034,0,5.573a10.668,10.668,0,0,0,9.651,0c2.667-1.538,2.667-4.034,0-5.573a10.668,10.668,0,0,0-9.651,0",
    transform: "translate(121.709 103.105)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275933",
    "data-name": "Path 275933",
    d: "M80.866,60.968a10.668,10.668,0,0,0-9.651,0,4.406,4.406,0,0,0-1.6,1.464,4.43,4.43,0,0,0,1.6,1.464,10.668,10.668,0,0,0,9.651,0,4.43,4.43,0,0,0,1.6-1.464,4.406,4.406,0,0,0-1.6-1.464",
    transform: "translate(121.965 104.789)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275934",
    "data-name": "Path 275934",
    d: "M73.535,75.367a12.712,12.712,0,0,0,11.23-6.638c4.1-7.474-.817-15.892-.817-15.892a12.317,12.317,0,0,1-5.022,3.39c-3.577,1.489-6.91,3.91-7.573,9.109a14.4,14.4,0,0,0,2.182,10.031",
    transform: "translate(124.771 92.565)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87547",
    "data-name": "Group 87547",
    transform: "translate(195.993 145.402)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87546",
    "data-name": "Group 87546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87545",
    "data-name": "Group 87545",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275935",
    "data-name": "Path 275935",
    d: "M73.535,75.367a12.712,12.712,0,0,0,11.23-6.638c4.1-7.474-.817-15.892-.817-15.892a12.317,12.317,0,0,1-5.022,3.39c-3.577,1.489-6.91,3.91-7.573,9.109a14.4,14.4,0,0,0,2.182,10.031",
    transform: "translate(-71.222 -52.838)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87550",
    "data-name": "Group 87550",
    transform: "translate(195.993 145.402)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87549",
    "data-name": "Group 87549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87548",
    "data-name": "Group 87548",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275936",
    "data-name": "Path 275936",
    d: "M83.948,52.837a12.344,12.344,0,0,1-5.022,3.39c-3.577,1.489-6.913,3.91-7.573,9.109a14.4,14.4,0,0,0,2.182,10.031c12.086-8.8,11.352-18.118,10.413-22.53",
    transform: "translate(-71.222 -52.838)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275937",
    "data-name": "Path 275937",
    d: "M81.617,53.761c1.263,7.158-2.865,14.624-8.842,18.462,5.319-4.645,9.065-11.291,8.842-18.462",
    transform: "translate(127.494 94.183)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275938",
    "data-name": "Path 275938",
    d: "M74.257,55.142c1.827,1.412,4.3,4.8,2.479,6.9a13.7,13.7,0,0,0-2.479-6.9",
    transform: "translate(130.09 96.603)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275939",
    "data-name": "Path 275939",
    d: "M79.912,75.1s-7.857-.572-10.848-6c-3.151-5.707.737-10.565-1.483-16.121,0,0,10.292,1.1,13.936,6.77,4.177,6.5,1.522,11.6-1.6,15.347",
    transform: "translate(118.394 92.827)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87553",
    "data-name": "Group 87553",
    transform: "translate(185.977 145.816)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87552",
    "data-name": "Group 87552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87551",
    "data-name": "Group 87551",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275940",
    "data-name": "Path 275940",
    d: "M81.515,59.757c-3.644-5.666-13.933-6.77-13.933-6.77C70.144,54.013,80.246,64.727,79.91,75.1c3.129-3.751,5.785-8.845,1.6-15.347",
    transform: "translate(-67.581 -52.988)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275941",
    "data-name": "Path 275941",
    d: "M68.079,53.312c6.175,4.764,11,12.557,10.966,20.513-.966-7.832-5.468-15-10.966-20.513",
    transform: "translate(119.267 93.397)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275942",
    "data-name": "Path 275942",
    d: "M68.816,56.966c2.05-.223,5.46-.619,6.481,1.541-2.35-.537-4.133-1.205-6.481-1.541",
    transform: "translate(120.558 99.482)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275943",
    "data-name": "Path 275943",
    d: "M111.2,125.67h-10.84l1.734,10.573h.017a1.945,1.945,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.017Z",
    transform: "translate(175.823 220.16)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275944",
    "data-name": "Path 275944",
    d: "M90.7,113.508H79.862L81.6,124.081h.016a1.946,1.946,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.016Z",
    transform: "translate(139.909 198.854)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275945",
    "data-name": "Path 275945",
    d: "M164,95.181h-10.84l1.734,10.573h.017a1.946,1.946,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.016Z",
    transform: "translate(268.318 166.747)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275946",
    "data-name": "Path 275946",
    d: "M143.5,83.02H132.66l1.734,10.573h.017a1.945,1.945,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.017Z",
    transform: "translate(232.406 145.442)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275947",
    "data-name": "Path 275947",
    d: "M229.57,71.1l-1.932,1.115L210.692,101.05a20.945,20.945,0,0,1-6.5,6.5l-123.15,71.1a2.918,2.918,0,0,0-1.706,2.331c-.022.875.019,6.181.005,7.031a2.869,2.869,0,0,0,1.7,2.411L138.5,223.6a9.146,9.146,0,0,0,8.239,0l145.872-84.3a9.118,9.118,0,0,0,4.12-7.138V112.4a9.118,9.118,0,0,0-4.12-7.136l-56.992-32.9c-2.276-1.313-4.984-1.88-6.051-1.263",
    transform: "translate(138.982 124.126)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275948",
    "data-name": "Path 275948",
    d: "M290.73,112.161,276.387,137a20.954,20.954,0,0,1-6.5,6.5L146.737,214.6a9.111,9.111,0,0,1-8.239,0L81.042,181.429c-2.276-1.313-2.276-3.443,0-4.755l123.153-71.1a20.975,20.975,0,0,0,6.5-6.5l14.533-24.731a4.8,4.8,0,0,1,6.53-1.723l57.234,33.045a4.756,4.756,0,0,1,1.742,6.5",
    transform: "translate(138.986 126.1)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275949",
    "data-name": "Path 275949",
    d: "M142.623,147.431v7.012a8.387,8.387,0,0,1-4.12-.991L81.041,120.289a2.872,2.872,0,0,1-1.692-2.416c.008-.828-.03-5.974-.011-6.984a2.878,2.878,0,0,0,1.7,2.38L138.5,146.441a8.417,8.417,0,0,0,4.12.991",
    transform: "translate(138.981 194.265)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275950",
    "data-name": "Path 275950",
    d: "M78.458,196.7v12.8a9.1,9.1,0,0,0,4.12,7.133l57.457,33.174a9.111,9.111,0,0,0,8.239,0l119.542-69.017a21.607,21.607,0,0,0,6.558-6.464l35.7-59.878a20.355,20.355,0,0,0,2.435-8.842V90.577a9.106,9.106,0,0,0-4.12-7.136L250.935,50.27a4.755,4.755,0,0,0-6.5,1.739L229.264,82.673l-20.647,31.38a30.084,30.084,0,0,1-4.329,5.248L84.743,188.318c-4.442,2.562-6.285,5.757-6.285,8.385",
    transform: "translate(137.45 86.948)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87556",
    "data-name": "Group 87556",
    transform: "translate(215.908 136.579)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87555",
    "data-name": "Group 87555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87554",
    "data-name": "Group 87554",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275951",
    "data-name": "Path 275951",
    d: "M78.458,196.7v12.8a9.1,9.1,0,0,0,4.12,7.133l57.457,33.174a9.111,9.111,0,0,0,8.239,0l119.542-69.017a21.607,21.607,0,0,0,6.558-6.464l35.7-59.878a20.355,20.355,0,0,0,2.435-8.842V90.577a9.106,9.106,0,0,0-4.12-7.136L250.935,50.27a4.755,4.755,0,0,0-6.5,1.739L229.264,82.673l-20.647,31.38a30.084,30.084,0,0,1-4.329,5.248L84.743,188.318c-4.442,2.562-6.285,5.757-6.285,8.385",
    transform: "translate(-78.458 -49.631)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87559",
    "data-name": "Group 87559",
    transform: "translate(215.904 276.785)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87558",
    "data-name": "Group 87558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87557",
    "data-name": "Group 87557",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275952",
    "data-name": "Path 275952",
    d: "M144.157,139.233v22.3a8.382,8.382,0,0,1-4.12-.98L82.576,127.378a9.108,9.108,0,0,1-4.12-7.133v-12.8a9.214,9.214,0,0,1,3.7-6.869c-1.847,1.321-1.7,3.264.418,4.491l57.462,33.171a8.417,8.417,0,0,0,4.12.991",
    transform: "translate(-78.458 -100.579)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275953",
    "data-name": "Path 275953",
    d: "M249.4,50.269l57.457,33.174a4.756,4.756,0,0,1,1.742,6.5l-35.821,62.041a20.917,20.917,0,0,1-6.5,6.5L146.737,227.5a9.111,9.111,0,0,1-8.239,0L81.042,194.325c-2.276-1.313-2.276-3.443,0-4.758,8.038-8.679,19.349-15.733,30.662-17.7,9.37-10.218,18.614-15.083,30.915-17.849,8.236-10.785,18.713-16.8,30.915-17.849a47.712,47.712,0,0,1,27.051-15.62,20.945,20.945,0,0,0,6.5-6.5c3.93-12.909,8.963-22.508,20.647-31.377,2.405-11.363,6.547-22.995,15.174-30.664a4.756,4.756,0,0,1,6.5-1.742",
    transform: "translate(138.986 86.949)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87562",
    "data-name": "Group 87562",
    transform: "translate(218.321 136.579)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87561",
    "data-name": "Group 87561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87560",
    "data-name": "Group 87560",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275954",
    "data-name": "Path 275954",
    d: "M249.4,50.269l57.457,33.174a4.756,4.756,0,0,1,1.742,6.5l-35.821,62.041a20.917,20.917,0,0,1-6.5,6.5L146.737,227.5a9.111,9.111,0,0,1-8.239,0L81.042,194.325c-2.276-1.313-2.276-3.443,0-4.758,8.038-8.679,19.349-15.733,30.662-17.7,9.37-10.218,18.614-15.083,30.915-17.849,8.236-10.785,18.713-16.8,30.915-17.849a47.712,47.712,0,0,1,27.051-15.62,20.945,20.945,0,0,0,6.5-6.5c3.93-12.909,8.963-22.508,20.647-31.377,2.405-11.363,6.547-22.995,15.174-30.664a4.756,4.756,0,0,1,6.5-1.742",
    transform: "translate(-79.335 -49.63)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87565",
    "data-name": "Group 87565",
    transform: "translate(342.863 136.579)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87564",
    "data-name": "Group 87564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87563",
    "data-name": "Group 87563",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275955",
    "data-name": "Path 275955",
    d: "M227.57,83.442,170.114,50.268a4.756,4.756,0,0,0-6.5,1.742c-8.627,7.672-12.769,19.3-15.174,30.664-11.687,8.872-16.718,18.468-20.647,31.377a19.34,19.34,0,0,1-3.2,3.91l.006.017L190.28,155.9a19.33,19.33,0,0,0,3.211-3.916l35.821-62.044a4.757,4.757,0,0,0-1.742-6.5",
    transform: "translate(-124.592 -49.632)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87568",
    "data-name": "Group 87568",
    transform: "translate(381.629 155.023)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87567",
    "data-name": "Group 87567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87566",
    "data-name": "Group 87566",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275956",
    "data-name": "Path 275956",
    d: "M155.224,68.579c-1.926-.523-3.883-.944-5.388-2.353a6.812,6.812,0,0,1-1.114-1.365,4.747,4.747,0,0,0-.817-1.288.7.7,0,0,0-.388-.124,7.279,7.279,0,0,1,1.423-3.715,12.83,12.83,0,0,1,1.3-1.747c.427-.449.952-.839,1.332-1.329.074-.094.036-.336-.116-.325a3.541,3.541,0,0,0-1.965,1.131,10.71,10.71,0,0,0-1.852,2.254,9.4,9.4,0,0,0-.947,2.105,5.262,5.262,0,0,0-.2.969,3,3,0,0,0-.022.512,1.614,1.614,0,0,0-.627-.253,11.84,11.84,0,0,1-3.322-1.522,8.265,8.265,0,0,1-3.743-4.315c-.022-.083-.1.025-.094.08a8.682,8.682,0,0,0,2.113,3.825,11.582,11.582,0,0,0,3.621,2.29,8.389,8.389,0,0,0,1.277.429A6.312,6.312,0,0,0,143.3,66.62a8.132,8.132,0,0,0-.732,5.028c.017.083.091.036.1-.025a17.653,17.653,0,0,1,.41-2.2,11.2,11.2,0,0,1,.892-2.265,5.928,5.928,0,0,1,2.788-2.821.332.332,0,0,0,.237-.4l.022,0a.62.62,0,0,0,.215-.041,3.653,3.653,0,0,0,.707,1.359,8.387,8.387,0,0,0,1.461,1.613,8.19,8.19,0,0,0,2.364,1.39,9.591,9.591,0,0,0,1.723.44,5.909,5.909,0,0,0,1.72.025c.052-.006.072-.124.016-.138",
    transform: "translate(-138.68 -56.333)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275957",
    "data-name": "Path 275957",
    d: "M145.062,61.71a2.523,2.523,0,1,0-3.245.625,2.347,2.347,0,0,0,3.245-.625",
    transform: "translate(246.108 101.978)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87571",
    "data-name": "Group 87571",
    transform: "translate(318.694 227.55)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87570",
    "data-name": "Group 87570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87569",
    "data-name": "Group 87569",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275958",
    "data-name": "Path 275958",
    d: "M116.286,92.546a10.409,10.409,0,0,1,4.563-3.28,11.9,11.9,0,0,1,2.083-.46,9.546,9.546,0,0,0,1.9-.264.537.537,0,0,0,.27-.248,12.8,12.8,0,0,1,4.409,1.951,15.659,15.659,0,0,1,1.9,1.368,18.215,18.215,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.176,12.176,0,0,0-2.4-1.893,15.194,15.194,0,0,0-2.455-1.205,10.684,10.684,0,0,0-1.2-.388,6.215,6.215,0,0,0-.658-.143,1.328,1.328,0,0,0,.5-.385,10.612,10.612,0,0,1,2.906-2.006,13.863,13.863,0,0,1,6.64-1.607c.113,0-.006-.083-.077-.088a17,17,0,0,0-2.834.066,14.427,14.427,0,0,0-2.713.5,13.084,13.084,0,0,0-3.985,2.025,6.539,6.539,0,0,0-.914.809,6.918,6.918,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.006-.074.058,0,.08.933.267,1.852.517,2.735.848a19.607,19.607,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.45.45,0,0,0,.454.27l-.006.017a.229.229,0,0,0-.008.165,7.664,7.664,0,0,0-1.959.168,14,14,0,0,0-2.5.647,8.686,8.686,0,0,0-2.466,1.351,6.012,6.012,0,0,0-1.054,1.126,2.772,2.772,0,0,0-.517,1.227c-.008.039.14.083.173.047",
    transform: "translate(-115.81 -82.689)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275959",
    "data-name": "Path 275959",
    d: "M118.922,86.677a4.84,4.84,0,0,0,4.345.006c1.227-.685,1.277-1.8.1-2.485a4.84,4.84,0,0,0-4.345-.006c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(206.855 146.598)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87574",
    "data-name": "Group 87574",
    transform: "translate(351.328 246.392)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87573",
    "data-name": "Group 87573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87572",
    "data-name": "Group 87572",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275960",
    "data-name": "Path 275960",
    d: "M128.145,99.392a10.409,10.409,0,0,1,4.563-3.28,11.906,11.906,0,0,1,2.083-.46,9.549,9.549,0,0,0,1.9-.264.538.538,0,0,0,.27-.248,12.8,12.8,0,0,1,4.408,1.951,15.659,15.659,0,0,1,1.9,1.368,18.238,18.238,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.18,12.18,0,0,0-2.4-1.893,15.193,15.193,0,0,0-2.455-1.205,10.68,10.68,0,0,0-1.2-.388,6.217,6.217,0,0,0-.658-.143,1.306,1.306,0,0,0,.5-.388,10.667,10.667,0,0,1,2.906-2,13.862,13.862,0,0,1,6.64-1.607c.113,0-.005-.083-.077-.088a17,17,0,0,0-2.834.066,14.428,14.428,0,0,0-2.713.5,13.083,13.083,0,0,0-3.985,2.025,6.541,6.541,0,0,0-.914.809,6.918,6.918,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.006-.074.058,0,.08.933.267,1.852.517,2.735.848a19.6,19.6,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.45.45,0,0,0,.454.27l-.005.017a.228.228,0,0,0-.008.165,7.661,7.661,0,0,0-1.959.168,14,14,0,0,0-2.5.647,8.687,8.687,0,0,0-2.466,1.351,6.01,6.01,0,0,0-1.054,1.126,2.771,2.771,0,0,0-.517,1.227c-.008.039.14.083.173.047",
    transform: "translate(-127.669 -89.537)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275961",
    "data-name": "Path 275961",
    d: "M130.781,93.524a4.84,4.84,0,0,0,4.345.005c1.227-.685,1.277-1.8.1-2.485a4.84,4.84,0,0,0-4.345-.005c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(227.63 158.593)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87577",
    "data-name": "Group 87577",
    transform: "translate(287.779 245.4)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87576",
    "data-name": "Group 87576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87575",
    "data-name": "Group 87575",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275962",
    "data-name": "Path 275962",
    d: "M105.052,99.032a10.408,10.408,0,0,1,4.563-3.28,11.9,11.9,0,0,1,2.083-.46,9.55,9.55,0,0,0,1.9-.264.538.538,0,0,0,.27-.248,12.8,12.8,0,0,1,4.409,1.951,15.658,15.658,0,0,1,1.9,1.368,18.192,18.192,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.179,12.179,0,0,0-2.4-1.893,15.2,15.2,0,0,0-2.455-1.205,10.678,10.678,0,0,0-1.2-.388,6.212,6.212,0,0,0-.658-.143,1.328,1.328,0,0,0,.5-.385,10.612,10.612,0,0,1,2.906-2.006,13.862,13.862,0,0,1,6.64-1.607c.113,0-.005-.083-.077-.088a17,17,0,0,0-2.834.066,14.429,14.429,0,0,0-2.713.5,13.084,13.084,0,0,0-3.985,2.025,6.541,6.541,0,0,0-.914.809,6.918,6.918,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.006-.074.058,0,.08.933.267,1.852.52,2.735.848a19.6,19.6,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.45.45,0,0,0,.454.27l-.006.017a.229.229,0,0,0-.008.165,7.661,7.661,0,0,0-1.959.168,13.994,13.994,0,0,0-2.5.647,8.685,8.685,0,0,0-2.466,1.351,6.011,6.011,0,0,0-1.054,1.126,2.772,2.772,0,0,0-.517,1.227c-.008.039.14.083.173.047",
    transform: "translate(-104.576 -89.175)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275963",
    "data-name": "Path 275963",
    d: "M107.688,93.163a4.84,4.84,0,0,0,4.345.006c1.227-.685,1.277-1.8.1-2.485a4.84,4.84,0,0,0-4.345-.006c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(187.174 157.961)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87580",
    "data-name": "Group 87580",
    transform: "translate(320.411 264.241)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87579",
    "data-name": "Group 87579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87578",
    "data-name": "Group 87578",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275964",
    "data-name": "Path 275964",
    d: "M116.911,105.878a10.409,10.409,0,0,1,4.563-3.28,11.9,11.9,0,0,1,2.083-.46,9.548,9.548,0,0,0,1.9-.264.537.537,0,0,0,.27-.248,12.8,12.8,0,0,1,4.409,1.951,15.653,15.653,0,0,1,1.9,1.368,18.217,18.217,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.236,12.236,0,0,0-2.4-1.893,15.344,15.344,0,0,0-2.457-1.205,10.679,10.679,0,0,0-1.2-.388,6.2,6.2,0,0,0-.658-.143,1.328,1.328,0,0,0,.5-.385,10.612,10.612,0,0,1,2.906-2.006,13.862,13.862,0,0,1,6.64-1.607c.113,0-.006-.083-.077-.088a17,17,0,0,0-2.834.066,14.427,14.427,0,0,0-2.713.5,13.084,13.084,0,0,0-3.985,2.025,6.54,6.54,0,0,0-.914.809,6.919,6.919,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.006-.074.058,0,.08.933.267,1.852.52,2.735.848a19.605,19.605,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.45.45,0,0,0,.454.27l-.006.017a.229.229,0,0,0-.008.165,7.662,7.662,0,0,0-1.959.168,14,14,0,0,0-2.5.647,8.684,8.684,0,0,0-2.466,1.351,6.011,6.011,0,0,0-1.054,1.126,2.772,2.772,0,0,0-.517,1.227c-.008.039.14.083.173.047",
    transform: "translate(-116.432 -96.023)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275965",
    "data-name": "Path 275965",
    d: "M119.547,100.01a4.84,4.84,0,0,0,4.345.006c1.227-.685,1.277-1.8.1-2.485a4.84,4.84,0,0,0-4.345-.006c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(207.949 169.956)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87583",
    "data-name": "Group 87583",
    transform: "translate(255.023 262.187)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87582",
    "data-name": "Group 87582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87581",
    "data-name": "Group 87581",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275966",
    "data-name": "Path 275966",
    d: "M93.15,105.132a10.409,10.409,0,0,1,4.563-3.28,11.9,11.9,0,0,1,2.083-.46,9.548,9.548,0,0,0,1.9-.264.537.537,0,0,0,.27-.248,12.8,12.8,0,0,1,4.409,1.951,15.654,15.654,0,0,1,1.9,1.368,18.21,18.21,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.176,12.176,0,0,0-2.4-1.893,15.2,15.2,0,0,0-2.455-1.205,10.69,10.69,0,0,0-1.2-.388,6.212,6.212,0,0,0-.658-.143,1.328,1.328,0,0,0,.5-.385,10.613,10.613,0,0,1,2.906-2.006,13.862,13.862,0,0,1,6.64-1.607c.113,0-.006-.083-.077-.088a17.006,17.006,0,0,0-2.834.066,14.431,14.431,0,0,0-2.713.5,13.083,13.083,0,0,0-3.985,2.025,6.536,6.536,0,0,0-.914.809,6.918,6.918,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.005-.074.058,0,.08.933.267,1.852.52,2.735.848a19.6,19.6,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.45.45,0,0,0,.454.27l-.006.017a.228.228,0,0,0-.008.165,7.663,7.663,0,0,0-1.959.168,14,14,0,0,0-2.5.647,8.685,8.685,0,0,0-2.466,1.351,6.014,6.014,0,0,0-1.054,1.126,2.772,2.772,0,0,0-.517,1.227c-.008.038.14.083.173.047",
    transform: "translate(-92.671 -95.276)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275967",
    "data-name": "Path 275967",
    d: "M95.787,99.261a4.84,4.84,0,0,0,4.345.008c1.227-.685,1.277-1.8.1-2.485a4.849,4.849,0,0,0-4.345-.008c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(166.323 168.649)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87586",
    "data-name": "Group 87586",
    transform: "translate(287.658 281.028)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87585",
    "data-name": "Group 87585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87584",
    "data-name": "Group 87584",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275968",
    "data-name": "Path 275968",
    d: "M105.008,111.979a10.408,10.408,0,0,1,4.563-3.28,11.9,11.9,0,0,1,2.083-.46,9.549,9.549,0,0,0,1.9-.264.538.538,0,0,0,.27-.248,12.8,12.8,0,0,1,4.409,1.951,15.657,15.657,0,0,1,1.9,1.368,18.207,18.207,0,0,0,1.346,1.288c.1.077.424.11.451,0,.14-.559-.41-1.189-.908-1.692a12.235,12.235,0,0,0-2.4-1.893,15.34,15.34,0,0,0-2.457-1.205,10.692,10.692,0,0,0-1.2-.388,6.209,6.209,0,0,0-.658-.143,1.329,1.329,0,0,0,.5-.385,10.613,10.613,0,0,1,2.906-2.006,13.863,13.863,0,0,1,6.64-1.607c.113,0-.006-.083-.077-.088a17.005,17.005,0,0,0-2.834.066,14.433,14.433,0,0,0-2.713.5,13.084,13.084,0,0,0-3.985,2.025,6.537,6.537,0,0,0-.914.809,6.918,6.918,0,0,0-2.931-2.411,17.142,17.142,0,0,0-6.3-1.786c-.113-.006-.074.058,0,.08.933.267,1.852.52,2.735.848a19.6,19.6,0,0,1,2.68,1.205c1.332.743,2.562,1.676,2.87,2.708a.449.449,0,0,0,.454.27l-.006.017a.228.228,0,0,0-.008.165,7.663,7.663,0,0,0-1.959.168,14,14,0,0,0-2.5.647,8.685,8.685,0,0,0-2.466,1.351,6.013,6.013,0,0,0-1.054,1.125,2.772,2.772,0,0,0-.517,1.227c-.008.039.14.083.173.047",
    transform: "translate(-104.532 -102.122)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275969",
    "data-name": "Path 275969",
    d: "M107.644,106.11a4.84,4.84,0,0,0,4.345.006c1.227-.685,1.277-1.8.1-2.485a4.84,4.84,0,0,0-4.345-.006c-1.227.685-1.274,1.8-.1,2.485",
    transform: "translate(187.097 180.642)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87589",
    "data-name": "Group 87589",
    transform: "translate(416.859 175.007)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87588",
    "data-name": "Group 87588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87587",
    "data-name": "Group 87587",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275970",
    "data-name": "Path 275970",
    d: "M168.026,75.841c-1.926-.523-3.883-.944-5.388-2.353a6.811,6.811,0,0,1-1.115-1.365,4.748,4.748,0,0,0-.817-1.288.721.721,0,0,0-.388-.124A7.279,7.279,0,0,1,161.741,67a12.815,12.815,0,0,1,1.3-1.747c.427-.449.952-.839,1.332-1.329.074-.094.036-.336-.116-.325a3.541,3.541,0,0,0-1.965,1.131,10.71,10.71,0,0,0-1.852,2.254,9.4,9.4,0,0,0-.947,2.105,5.269,5.269,0,0,0-.2.969,3,3,0,0,0-.022.512,1.615,1.615,0,0,0-.627-.253,11.841,11.841,0,0,1-3.322-1.522,8.265,8.265,0,0,1-3.743-4.315c-.022-.083-.1.025-.094.08a8.684,8.684,0,0,0,2.113,3.825,11.552,11.552,0,0,0,3.622,2.29,8.386,8.386,0,0,0,1.277.429,6.311,6.311,0,0,0-2.391,2.782,8.152,8.152,0,0,0-.735,5.028c.019.083.094.036.1-.025a17.509,17.509,0,0,1,.41-2.2,11.164,11.164,0,0,1,.892-2.268,5.928,5.928,0,0,1,2.788-2.821.332.332,0,0,0,.237-.4l.022,0a.62.62,0,0,0,.215-.041,3.652,3.652,0,0,0,.707,1.359,8.385,8.385,0,0,0,1.461,1.613,8.189,8.189,0,0,0,2.364,1.39,9.591,9.591,0,0,0,1.723.44,5.909,5.909,0,0,0,1.72.025c.052-.005.072-.124.017-.138",
    transform: "translate(-151.482 -63.596)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275971",
    "data-name": "Path 275971",
    d: "M157.865,68.972a2.523,2.523,0,1,0-3.244.625,2.347,2.347,0,0,0,3.244-.625",
    transform: "translate(268.538 114.7)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87592",
    "data-name": "Group 87592",
    transform: "translate(363.841 184.611)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87591",
    "data-name": "Group 87591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87590",
    "data-name": "Group 87590",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275972",
    "data-name": "Path 275972",
    d: "M148.76,79.331c-1.926-.523-3.883-.944-5.388-2.353a6.814,6.814,0,0,1-1.115-1.365,4.748,4.748,0,0,0-.817-1.288.722.722,0,0,0-.388-.124,7.28,7.28,0,0,1,1.423-3.715,12.831,12.831,0,0,1,1.3-1.747c.427-.449.952-.839,1.332-1.329.074-.094.036-.336-.116-.325a3.541,3.541,0,0,0-1.965,1.131,10.712,10.712,0,0,0-1.852,2.254,9.4,9.4,0,0,0-.947,2.105,5.264,5.264,0,0,0-.2.969,2.99,2.99,0,0,0-.022.512,1.616,1.616,0,0,0-.628-.253,11.839,11.839,0,0,1-3.322-1.522,8.265,8.265,0,0,1-3.743-4.315c-.022-.083-.1.025-.094.08a8.681,8.681,0,0,0,2.113,3.825,11.551,11.551,0,0,0,3.621,2.29,8.385,8.385,0,0,0,1.277.429,6.311,6.311,0,0,0-2.391,2.782A8.152,8.152,0,0,0,136.1,82.4c.019.083.094.036.1-.025a17.533,17.533,0,0,1,.41-2.2,11.161,11.161,0,0,1,.892-2.268,5.928,5.928,0,0,1,2.788-2.821.332.332,0,0,0,.237-.4l.022,0a.62.62,0,0,0,.215-.041A3.653,3.653,0,0,0,141.476,76a8.39,8.39,0,0,0,1.461,1.613A8.19,8.19,0,0,0,145.3,79a9.587,9.587,0,0,0,1.723.44,5.907,5.907,0,0,0,1.72.025c.052-.006.072-.124.017-.138",
    transform: "translate(-132.216 -67.086)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275973",
    "data-name": "Path 275973",
    d: "M138.6,72.462a2.523,2.523,0,1,0-3.244.625,2.347,2.347,0,0,0,3.244-.625",
    transform: "translate(234.786 120.814)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87595",
    "data-name": "Group 87595",
    transform: "translate(398.586 204.998)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87594",
    "data-name": "Group 87594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87593",
    "data-name": "Group 87593",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275974",
    "data-name": "Path 275974",
    d: "M161.386,86.739c-1.926-.523-3.883-.944-5.388-2.353a6.811,6.811,0,0,1-1.115-1.365,4.749,4.749,0,0,0-.817-1.288.721.721,0,0,0-.388-.124,7.28,7.28,0,0,1,1.423-3.715,12.819,12.819,0,0,1,1.3-1.747c.427-.449.952-.839,1.332-1.329.074-.094.036-.336-.116-.325a3.541,3.541,0,0,0-1.965,1.131,10.713,10.713,0,0,0-1.852,2.254,9.393,9.393,0,0,0-.947,2.105,5.26,5.26,0,0,0-.2.969,3.005,3.005,0,0,0-.022.512,1.62,1.62,0,0,0-.625-.253,11.822,11.822,0,0,1-3.324-1.522,8.265,8.265,0,0,1-3.743-4.315c-.022-.083-.1.025-.094.08a8.682,8.682,0,0,0,2.113,3.825,11.582,11.582,0,0,0,3.621,2.29,8.385,8.385,0,0,0,1.277.429,6.311,6.311,0,0,0-2.391,2.782,8.131,8.131,0,0,0-.732,5.028c.016.083.091.036.1-.025a17.529,17.529,0,0,1,.41-2.2,11.157,11.157,0,0,1,.892-2.268,5.928,5.928,0,0,1,2.788-2.821.332.332,0,0,0,.237-.4l.022,0a.62.62,0,0,0,.215-.041,3.652,3.652,0,0,0,.707,1.359,8.48,8.48,0,0,0,1.461,1.613,8.191,8.191,0,0,0,2.364,1.39,9.59,9.59,0,0,0,1.723.44,5.909,5.909,0,0,0,1.72.025c.052-.005.072-.124.017-.138",
    transform: "translate(-144.842 -74.494)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275975",
    "data-name": "Path 275975",
    d: "M151.224,79.87a2.523,2.523,0,1,0-3.244.625,2.347,2.347,0,0,0,3.244-.625",
    transform: "translate(256.903 133.792)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87598",
    "data-name": "Group 87598",
    transform: "translate(241.7 136.579)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87597",
    "data-name": "Group 87597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87596",
    "data-name": "Group 87596",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275976",
    "data-name": "Path 275976",
    d: "M272.911,107.756c-3.833,2.818-9.073,5.812-12.939,3.044-3.366-2.408-3.005-7.623-1.17-11.332s4.774-6.938,5.683-10.975c2.061-9.172-6.962-17.287-9.178-26.22l-20.791-12a4.76,4.76,0,0,0-6.5,1.742c-.19.168-.366.349-.553.523-.421.919-.817,1.852-1.211,2.777q-1.094,2.584-2.177,5.174a152.575,152.575,0,0,0-6.717,18.848,30.647,30.647,0,0,0-.823,4.139,15.568,15.568,0,0,1-1.6,4.007c-1.324,3.024-2.5,6.115-3.611,9.224-2.006,5.608-3.822,11.286-6.01,16.828-2.064,5.226-4.433,10.881-7.785,15.422-1.621,2.2-4.535,4-6.767,5.515a70.184,70.184,0,0,1-7.628,4.464,160.867,160.867,0,0,1-16.266,6.891c-2.939,1.109-5.881,2.212-8.792,3.385a95.844,95.844,0,0,0-15.851,7.826,86.365,86.365,0,0,0-13.944,11.558c-4.593,4.538-8.754,9.524-13.619,13.77a61.49,61.49,0,0,1-18.8,11.217c-2.009.754-4.337,1.307-6.109,2.556a4.291,4.291,0,0,0-1.91,2.923,4.027,4.027,0,0,0,1,2.928,8.055,8.055,0,0,0,2.529,1.891,16.708,16.708,0,0,0,15.452-.184c3.107-1.706,5.619-4.392,8.831-5.895a25.789,25.789,0,0,1,5.383-1.64,3.061,3.061,0,0,1,1.714-.047c3.432,1.263-6.178,6.47-7.16,7.056-1.745,1.046-3.522,2.039-5.171,3.231-1.208.872-3.481,2.24-3.575,3.88a3.4,3.4,0,0,0,.908,2.369,7.451,7.451,0,0,0,2.078,1.552,19.8,19.8,0,0,0,7.89,2.174,16.583,16.583,0,0,0,11-2.73c2.047-1.412,3.8-3.305,6.093-4.263s5.094-.944,6.968-2.6a13.04,13.04,0,0,0,2.46-3.795c1.75-3.231,5.914-5.066,9-6.852,3.52-2.042,7.119-4.056,10.1-6.869,3.99-3.765,6.616-8.721,10.066-12.983a27.974,27.974,0,0,1,14.747-9.874l5.884-1.436c3.377-.826,6.742-1.747,10.141-2.477,2.906-.625,5.873-1.029,8.79-1.643,5.906-1.241,11.814-2.989,16.891-6.354.542-.36,1.076-.74,1.593-1.137,9.183-7.017,12.956-18.861,16.222-29.949,2.713,5.713,10.138,7.857,16.316,6.511a28.184,28.184,0,0,0,8.806-3.765L285.077,104.9c-3.528-2.248-8.6.234-12.166,2.856",
    transform: "translate(-87.832 -49.63)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275977",
    "data-name": "Path 275977",
    d: "M116.41,89.957s-8.946,17.389-12.273,21.489a39.641,39.641,0,0,1-9.167,8.679c-.845.6-2.694,1.657-3.385,2.141a1.229,1.229,0,0,0-.322,1.871c1.035,1.618,6.682,3.316,10.471,1.69s7.953-6.032,10.333-7.5c.894-.553,1.75-1.131,2.587-1.764.8-.608.809-1.373,1.07-2.21.127-.407.341-1.544.341-1.544.927-1.907,10.609-13.256,11.718-15.064Z",
    transform: "translate(159.373 157.595)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275978",
    "data-name": "Path 275978",
    d: "M120.3,101.641a4.466,4.466,0,0,1-.5,1.423c-.509.7-3.817,1.69-5.066,2.014a6.961,6.961,0,0,0-4.194,2.947,11.961,11.961,0,0,1-7.1,4.183A19.032,19.032,0,0,1,92.2,111.083c-4.433-1.778-4.249-4.568-4.249-4.568s.283-2.606,1.511-2.774,30.846-2.1,30.846-2.1",
    transform: "translate(154.071 178.064)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275979",
    "data-name": "Path 275979",
    d: "M121.287,100.726c.11.083.327.206.333.768,0,.212-.638,2.334-.779,3.6-.149,1.362-.014,4-.933,5.512-2.95,1.97-6.9,1.808-9.279,4s-4.752,5.039-11.032,4.995-10.463-2.9-11.222-4.849.589-3.355,4.885-4.645c4.56-1.37,11.319-6.86,11.321-6.863a27.91,27.91,0,0,0,2.645-2.521,23.546,23.546,0,0,0,1.99-3,2.669,2.669,0,0,1,1.2-1.117,2.731,2.731,0,0,1,1.637.121,12.025,12.025,0,0,1,2.5.919,4.031,4.031,0,0,1,1.827,1.88,18.47,18.47,0,0,0,.611,1.827,2.33,2.33,0,0,0,2.149,1.181,1.991,1.991,0,0,0,1.9-1.315,4.854,4.854,0,0,0,.25-.49",
    transform: "translate(154.469 169.091)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275980",
    "data-name": "Path 275980",
    d: "M103.913,110.9a7.823,7.823,0,0,0-3.118-7.469c-4.07-3.261-7.144-2.331-8.74-1.615-1.9.853-4.786,2.854-3.718,4.959,1.15,2.273,3.448,3.715,8.08,4.725a11.286,11.286,0,0,0,7.5-.6",
    transform: "translate(154.354 177.155)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275981",
    "data-name": "Path 275981",
    d: "M101.553,103.362a.54.54,0,0,1-.369-.3c-.369-.826-3.123-4.2-6.5-3.965-.088-.4.259-.729,1-.988,3.421.391,6.04,3.566,6.486,4.563a.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022",
    transform: "translate(165.848 171.876)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275982",
    "data-name": "Path 275982",
    d: "M93.827,99.793a1.611,1.611,0,0,1,1.134-.925,9.75,9.75,0,0,1,6.062,4.5.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022.546.546,0,0,1-.369-.3c-.358-.8-2.975-4-6.217-3.971",
    transform: "translate(164.375 173.206)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275983",
    "data-name": "Path 275983",
    d: "M91.616,101.378a2.962,2.962,0,0,1,1.706-1.048,9.638,9.638,0,0,1,6.346,4.546.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022.552.552,0,0,1-.369-.3c-.388-.872-3.437-4.576-7.072-3.888",
    transform: "translate(160.501 175.767)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275984",
    "data-name": "Path 275984",
    d: "M99.574,104.8a.54.54,0,0,1-.369-.3c-.366-.817-3.066-4.117-6.393-3.968a1.832,1.832,0,0,1,1.31-.927,9.742,9.742,0,0,1,6.062,4.5.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022",
    transform: "translate(162.598 174.501)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275985",
    "data-name": "Path 275985",
    d: "M124.269,94.518s-9.486,15.807-12.813,19.907a41.743,41.743,0,0,1-9.464,8.867c-.848.6-2.7,1.657-3.388,2.141a1.23,1.23,0,0,0-.319,1.871c1.035,1.618,6.679,3.316,10.468,1.69s7.953-6.032,10.333-7.5c.9-.553,1.753-1.131,2.587-1.764.806-.608.812-1.373,1.073-2.21.127-.407.341-1.544.341-1.544.925-1.9,11.514-11.767,13.27-13.82Z",
    transform: "translate(171.675 165.585)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275986",
    "data-name": "Path 275986",
    d: "M127.325,105.694a4.465,4.465,0,0,1-.5,1.423c-.509.7-3.817,1.69-5.066,2.014a6.96,6.96,0,0,0-4.194,2.947,11.961,11.961,0,0,1-7.1,4.183,19.033,19.033,0,0,1-11.244-1.125c-4.433-1.778-4.249-4.568-4.249-4.568s.283-2.606,1.511-2.774,30.846-2.1,30.846-2.1",
    transform: "translate(166.373 185.164)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275987",
    "data-name": "Path 275987",
    d: "M128.308,104.78c.11.083.327.206.333.768,0,.212-.638,2.334-.779,3.605-.149,1.362-.014,4-.933,5.512-2.95,1.97-6.9,1.808-9.279,4s-4.753,5.039-11.032,4.995-10.463-2.9-11.222-4.849.589-3.355,4.885-4.645c4.56-1.37,11.319-6.86,11.321-6.863a27.9,27.9,0,0,0,2.645-2.521,23.547,23.547,0,0,0,1.99-3,2.669,2.669,0,0,1,1.2-1.117,2.731,2.731,0,0,1,1.637.121,12.026,12.026,0,0,1,2.5.919,4.031,4.031,0,0,1,1.827,1.88,18.482,18.482,0,0,0,.611,1.827,2.33,2.33,0,0,0,2.149,1.181,1.991,1.991,0,0,0,1.9-1.315,4.857,4.857,0,0,0,.25-.49",
    transform: "translate(166.769 176.193)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275988",
    "data-name": "Path 275988",
    d: "M110.935,114.955a7.823,7.823,0,0,0-3.118-7.469c-4.07-3.261-7.144-2.331-8.74-1.615-1.9.853-4.786,2.854-3.718,4.959,1.15,2.273,3.448,3.715,8.08,4.725a11.286,11.286,0,0,0,7.5-.6",
    transform: "translate(166.656 184.258)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275989",
    "data-name": "Path 275989",
    d: "M108.574,107.416a.54.54,0,0,1-.369-.3c-.369-.826-3.123-4.2-6.5-3.965-.088-.4.259-.729,1-.988,3.421.391,6.04,3.566,6.486,4.563a.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022",
    transform: "translate(178.148 178.978)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275990",
    "data-name": "Path 275990",
    d: "M100.848,103.847a1.611,1.611,0,0,1,1.134-.925,9.742,9.742,0,0,1,6.062,4.5.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022.546.546,0,0,1-.369-.3c-.358-.8-2.975-4-6.217-3.971",
    transform: "translate(176.675 180.308)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275991",
    "data-name": "Path 275991",
    d: "M98.638,105.432a2.962,2.962,0,0,1,1.706-1.048,9.639,9.639,0,0,1,6.346,4.546.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022.552.552,0,0,1-.369-.3c-.388-.872-3.437-4.576-7.072-3.888",
    transform: "translate(172.803 182.869)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275992",
    "data-name": "Path 275992",
    d: "M106.6,108.857a.54.54,0,0,1-.369-.3c-.366-.817-3.066-4.117-6.393-3.968a1.832,1.832,0,0,1,1.31-.927,9.742,9.742,0,0,1,6.062,4.5.5.5,0,0,1-.278.669.577.577,0,0,1-.333.022",
    transform: "translate(174.9 181.603)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275993",
    "data-name": "Path 275993",
    d: "M196.9,71.491c-.083,6.8-.077,12.084-3.655,18.281s-10.485,9.725-20.755,13.154c-8.5,2.837-30.642,3.864-34.209,4.521-2.488.457-5.4.721-7.083,4.21-1.926,3.988-2.372,4.389-7.458,9.489-6.577,6.6-8.033,7.961-12.879,12.422-3.333,1.079-9.9-3.132-11.751-6.415,0,0,14.453-26.916,18.185-31.735,3.979-5.138,26.919-12.331,37.519-15.482,3.531-1.051,22.321-4.9,22.321-4.9Z",
    transform: "translate(173.628 125.244)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275994",
    "data-name": "Path 275994",
    d: "M196.9,71.491c-.083,6.8-.077,12.084-3.655,18.281s-10.485,9.725-20.755,13.154c-8.5,2.837-30.642,3.864-34.209,4.521-2.488.457-5.4.721-7.083,4.21-1.926,3.988-2.372,4.389-7.458,9.489-6.577,6.6-8.033,7.961-12.879,12.422-3.333,1.079-9.9-3.132-11.751-6.415,0,0,14.453-26.916,18.185-31.735,3.979-5.138,26.919-12.331,37.519-15.482,3.531-1.051,22.321-4.9,22.321-4.9Z",
    transform: "translate(173.628 125.244)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275995",
    "data-name": "Path 275995",
    d: "M122.737,101.764c3.566-.658,25.7-1.684,34.206-4.521h0c10.27-3.429,17.175-6.957,20.755-13.154.272-.473.52-.941.751-1.406.055-.1.1-.209.154-.316l.014-.025c.187-.388.363-.776.526-1.159l.036-.085.058-.135a24.27,24.27,0,0,0,.982-2.884l-18.149-3.343a33.337,33.337,0,0,0,.941,10.578S135.77,92.075,130.425,94.1c-6.294,2.38-14.379,3.624-15.664,9.056-.735,3.115-2.27,7.015-6.781,12.524.074-.072.14-.138.215-.215,5.085-5.1,5.531-5.5,7.458-9.489,1.687-3.489,4.6-3.751,7.083-4.21",
    transform: "translate(189.171 130.928)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275996",
    "data-name": "Path 275996",
    d: "M106.8,134.463c2.79,5.958,11.153,8.324,11.153,8.324s5.278-4.587,12.128-10.9c4.065-3.745,5.374-6.261,7.755-10.009,2.086-3.283,5.05-2.961,7.526-3.5s25.5-2.653,34.242-4.609c7.8-1.747,13.215-4.593,17.733-10.141.482-.586.927-1.189,1.346-1.808,2.5-3.663,4.032-8.113,5.471-15.788l-31.113-9.9-9.422-3-.228-.069c.044.991.663,4.04.845,5.061a51.72,51.72,0,0,0,4.07,12.095l.008.025s-37.351,8.924-42.654,15.777c-3.734,4.819-18.859,28.438-18.859,28.438",
    transform: "translate(187.097 128.007)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275997",
    "data-name": "Path 275997",
    d: "M147.093,42.853c3.319-1.959,13.16-4.5,21.217,1.615s7.554,14.973,7.708,25.573c.1,7.21,1.376,15.76,4.689,21.922,3.605,6.709,4.964,14.1-1.472,19.3s-23.972,4.907-30.915,3.1-19.949-8.311-16.533-20.149,9.219-10.031,10.449-18.388,4.857-32.97,4.857-32.97",
    transform: "translate(229.894 71.167)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275998",
    "data-name": "Path 275998",
    d: "M134.072,72.6a16.609,16.609,0,0,1,.693-2.554c1.34-4.04.787-8.36-.033-12.447-.14-.7-.289-1.4-.438-2.094a7.688,7.688,0,0,1-.19-1.018c-.027-.327-.061-.6-.465-.685a1.2,1.2,0,0,0-.831.2,3.487,3.487,0,0,0-1.475,2.4,16.95,16.95,0,0,0-.124,2.9c-.011.74-.682.228-.963-.061-1.381-1.42-2.072-4.488-2.512-6.382a25.8,25.8,0,0,0-.826-3.737,3.921,3.921,0,0,0-1.417-1.863c-.451-.294-.963-.413-1.274.184a2.718,2.718,0,0,0-.176,1.23,2.9,2.9,0,0,1-.691,2.273,6.691,6.691,0,0,0-1.208,1.225,19.631,19.631,0,0,0-.663,2.089c-.272.594-.828.947-1.142,1.481A5.373,5.373,0,0,0,120,57.962a17.6,17.6,0,0,0,.424,4.6,33.636,33.636,0,0,0,2.336,6.621,9.257,9.257,0,0,1,1.112,3.723,20.1,20.1,0,0,1-.506,3.894c-.322,1.61-.542,3.242-1,4.821-4,13.96-3.346,16.462-1.211,22,.748,1.937,3.729,5.154,10.831,2.152,7.873-3.324,24.594-13.545,24.594-13.545l10.6-18.237a34.3,34.3,0,0,0-5.044-1.026c-2.579-.322-5.988.96-8.721,2.851-5.666,3.919-20.325,14.12-20.325,14.12s.754-14.965.974-17.331",
    transform: "translate(209.287 82.368)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275999",
    "data-name": "Path 275999",
    d: "M124.592,52.5a12.771,12.771,0,0,0-1.211,7,7.463,7.463,0,0,1-.548-3.809c.371-1.984,1-2.669,1.758-3.187",
    transform: "translate(215.054 91.969)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276000",
    "data-name": "Path 276000",
    d: "M158.507,57.479c-2.218-.6-4.453-1.855-9.1-.6s-22.513,14.475-23.413,14.8-1.505.567-1.505.567l-.069,1.357s2.479,5.636,1.987,9.428a14.21,14.21,0,0,1-1.987,5.925,2.379,2.379,0,0,0,2.565.636c1.588-.542,3.311-2.309,4.755-3.107S151.09,75.328,151.09,75.328Z",
    transform: "translate(217.968 98.702)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87601",
    "data-name": "Group 87601",
    transform: "translate(342.387 155.042)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87600",
    "data-name": "Group 87600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87599",
    "data-name": "Group 87599",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276001",
    "data-name": "Path 276001",
    d: "M158.507,57.479c-2.218-.6-4.453-1.855-9.1-.6s-22.513,14.475-23.413,14.8-1.505.567-1.505.567l-.069,1.357s2.479,5.636,1.987,9.428a14.21,14.21,0,0,1-1.987,5.925,2.379,2.379,0,0,0,2.565.636c1.588-.542,3.311-2.309,4.755-3.107S151.09,75.328,151.09,75.328Z",
    transform: "translate(-124.419 -56.34)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276002",
    "data-name": "Path 276002",
    d: "M127.571,62.614c1.241,1.613,4.254,8.806,0,15.353a14.737,14.737,0,0,1-4.951,1.607c2.119-1.536,5.457-6.72,4.951-15.653Z",
    transform: "translate(214.817 109.693)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276003",
    "data-name": "Path 276003",
    d: "M167.576,59.633l8.2,3.057s3.52,2.152,3.635,12.477a52.37,52.37,0,0,1-1.31,13.74c-3.864,21.393-12.579,35.351-12.579,35.351a101.494,101.494,0,0,1-22.2-9.494c-12.477-7.207-15.859-13.914-15.859-13.914l9.5-7.606,2.493-11.387s-4.582-5.025-2.347-10.84c3.1-8.063,16.066-14.263,16.066-14.263Z",
    transform: "translate(223.299 99.429)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276004",
    "data-name": "Path 276004",
    d: "M138.726,43.468c-1.123,1.015-5.085,4.887-5.085,17.543,0,10.831,3.016,13.407,4.7,14.3s4.425.867,7.73.572l-.4,5.215S130,92.441,139.516,95.649s20.24-11.192,20.24-11.192l1.12-15.358s1.78,2.012,5.253-.586c2.868-2.146,4.076-6.04,2.144-8.327a4.7,4.7,0,0,0-7.565.916s-7.656-3.159-5.826-15.631c-6.5.605-12.532.638-16.156-2",
    transform: "translate(234.124 76.151)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276005",
    "data-name": "Path 276005",
    d: "M138.091,49.881a1.349,1.349,0,1,0,1.514-1.225,1.367,1.367,0,0,0-1.514,1.225",
    transform: "translate(241.899 85.223)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276006",
    "data-name": "Path 276006",
    d: "M137.91,46.853l-3.145,1.062a1.594,1.594,0,0,0,2.05,1.073,1.745,1.745,0,0,0,1.1-2.135",
    transform: "translate(236.093 82.081)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276007",
    "data-name": "Path 276007",
    d: "M141.549,49.012l-2.722-1.9a1.6,1.6,0,0,0,.352,2.287,1.746,1.746,0,0,0,2.369-.385",
    transform: "translate(242.628 82.532)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276008",
    "data-name": "Path 276008",
    d: "M134.38,49.467a1.349,1.349,0,1,0,1.514-1.225,1.371,1.371,0,0,0-1.514,1.225",
    transform: "translate(235.397 84.498)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276009",
    "data-name": "Path 276009",
    d: "M140.421,48.19l-.812,8.594-4.574-1.47Z",
    transform: "translate(236.567 84.424)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276010",
    "data-name": "Path 276010",
    d: "M138.261,59.174a21.359,21.359,0,0,0,8.085-2.3,9.734,9.734,0,0,0,3.932-3.872,8.084,8.084,0,0,1-3.2,5.072c-3.3,2.675-8.977,3.236-8.977,3.236Z",
    transform: "translate(241.934 92.862)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276011",
    "data-name": "Path 276011",
    d: "M140.181,53.682a1.54,1.54,0,1,1-1.538-1.541,1.537,1.537,0,0,1,1.538,1.541",
    transform: "translate(240.188 91.345)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276012",
    "data-name": "Path 276012",
    d: "M149.34,41.028c-5.815-1.4-11.641,1.167-14.313,5.22a14.339,14.339,0,0,0-2.105,9.01l5.262,1a19.373,19.373,0,0,1,1.844-6.211,15.994,15.994,0,0,0-.237,6.7s3.665.622,8.176,1.021a22.2,22.2,0,0,1,1.436-6.547,26.572,26.572,0,0,0,0,6.632c2.072.113,5.793.275,7.526.182l3.36-12.317s-6.737-3.671-10.952-4.689",
    transform: "translate(232.738 71.199)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276013",
    "data-name": "Path 276013",
    d: "M208.8,77.954a3.958,3.958,0,0,0-2.317-.245,24.82,24.82,0,0,0-3.638,1.227c-1.855.583-4.83,1.588-6.759,1.128-.393-.083-1.189-.413-.559-.8a14.861,14.861,0,0,0,2.419-1.6,3.448,3.448,0,0,0,1.3-2.479,1.347,1.347,0,0,0-.256-.828c-.281-.289-.531-.182-.834-.041a7.347,7.347,0,0,1-.969.363c-.688.239-1.351.462-2.02.707-3.921,1.4-7.9,3.165-10.691,6.4a17.592,17.592,0,0,1-1.822,1.913c-1.921,1.412-17.378,8.36-17.378,8.36s-5.628-16.952-7.829-23.487c-1.059-3.143-2.7-6.434-4.959-7.716a16.608,16.608,0,0,0-4.139-1.767c-5.8,6.737-5.972,13.44-3.25,20.747,0,0,7.276,18.2,11.58,25.565a14.373,14.373,0,0,0,.908,1.4c.016.025.033.052.055.058,1.387,1.822,3.822,2.532,8.627.476,3.162-1.351,7.337-3.921,12.879-8.206,1.962-1.494,7.361-5.856,8.512-6.544a9.44,9.44,0,0,1,3.762-.971,33.143,33.143,0,0,0,6.871-1.425,16.761,16.761,0,0,0,4.166-2,5.7,5.7,0,0,0,1.742-1.428A13.1,13.1,0,0,1,204.879,85c.4-.6,1.1-1,1.442-1.629a6.438,6.438,0,0,0,.429-1.687,2.891,2.891,0,0,1,1.585-1.758,2.618,2.618,0,0,0,.963-.773c.352-.586,0-.958-.5-1.2",
    transform: "translate(251.233 103.5)",
    fill: "#febc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276014",
    "data-name": "Path 276014",
    d: "M165.057,67.206a12.746,12.746,0,0,1-5.369,4.645,7.457,7.457,0,0,0,3.547-1.494c1.505-1.343,1.769-2.235,1.822-3.151",
    transform: "translate(279.756 117.738)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276015",
    "data-name": "Path 276015",
    d: "M148.467,58.912c3.8,1.17,5.889,2.127,7.8,4.995s7.188,20.009,8.289,22.662,2.636,4.078,1.362,5.765c0,0-8.275,3.206-11.1,8.6-2.375,1-1.891-1.94-2.7-3.6s-8.085-19.255-8.085-19.255-4.084-12.513,4.439-19.161",
    transform: "translate(250.609 103.207)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87604",
    "data-name": "Group 87604",
    transform: "translate(393.661 162.12)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87603",
    "data-name": "Group 87603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87602",
    "data-name": "Group 87602",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276016",
    "data-name": "Path 276016",
    d: "M148.467,58.912c3.8,1.17,5.889,2.127,7.8,4.995s7.188,20.009,8.289,22.662,2.636,4.078,1.362,5.765c0,0-8.275,3.206-11.1,8.6-2.375,1-1.891-1.94-2.7-3.6s-8.085-19.255-8.085-19.255-4.084-12.513,4.439-19.161",
    transform: "translate(-143.052 -58.913)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276017",
    "data-name": "Path 276017",
    d: "M158.428,71.058a29.311,29.311,0,0,0-7.394,7.766,12.364,12.364,0,0,0-1.659,4.794l-2.05-3.963s1.1-5.424,11.1-8.6",
    transform: "translate(258.095 124.486)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276018",
    "data-name": "Path 276018",
    d: "M147.227,62.559l-6.682,5.952L143.9,57.143s-15.7,11.3-6.192,14.513,20.243-11.189,20.243-11.189l.03-.424Z",
    transform: "translate(235.894 100.108)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276019",
    "data-name": "Path 276019",
    d: "M136.794,69.194s5.306-6.4,6.715-7.353,6.5,1.172,10.887-2.854l.165-2.232s.5-.124,1.126,1.483c.644,1.646,1.42,3.588,1.42,3.588s-.2,3.437-4.166,6.084c-4.824,3.214-7.226,3.586-7.942,1.183a19.591,19.591,0,0,0-1.929-4.472Z",
    transform: "translate(239.648 99.425)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276020",
    "data-name": "Path 276020",
    d: "M139.382,70.269,142.74,58.9l.234-2.744c-.671-.168-1.34.842-2.237,1.885s-6.093,6.027-5.347,8.3a7.791,7.791,0,0,1,4.186-2.57Z",
    transform: "translate(237.06 98.35)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276021",
    "data-name": "Path 276021",
    d: "M46.039,117.562H35.2l1.734,10.573h.017a1.945,1.945,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.017Z",
    transform: "translate(61.665 205.956)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276022",
    "data-name": "Path 276022",
    d: "M24.224,105.839H13.384l1.734,10.573h.017a1.945,1.945,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.017Z",
    transform: "translate(23.447 185.418)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276023",
    "data-name": "Path 276023",
    d: "M75.529,100.536H64.689l1.734,10.573h.017a1.945,1.945,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3H73.8Z",
    transform: "translate(113.328 176.128)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276024",
    "data-name": "Path 276024",
    d: "M54.992,89.433H44.152l1.734,10.573H45.9a1.946,1.946,0,0,0,1.048,1.3,5.806,5.806,0,0,0,5.242,0,1.95,1.95,0,0,0,1.051-1.3h.017Z",
    transform: "translate(77.349 156.677)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276025",
    "data-name": "Path 276025",
    d: "M178.092,127.059v50.481a11.653,11.653,0,0,1-5.256,9.1l-4.285,2.477-.072.036a11.84,11.84,0,0,1-6.569,1.131L97.58,224.327a11.729,11.729,0,0,1-5.2,8.737.12.12,0,0,0-.05.025l-4.271,2.463a1.989,1.989,0,0,1-.4.206,1.615,1.615,0,0,1-.217.11c-.025.011-.05.011-.061.025a11.982,11.982,0,0,1-8.157.377,7.472,7.472,0,0,1-.911-.341c-.05-.025-.1-.036-.146-.061-.217-.1-.424-.206-.619-.316L15.645,199.907a11.637,11.637,0,0,1-5.256-9.1l-.091-63.91-.006-22.172a11.67,11.67,0,0,1,5.256-9.1L84.781,55.724a10.872,10.872,0,0,1,10.143.168l4.285,2.466a13.971,13.971,0,0,1,6.057,9.054l4.125,24.921,3.811-2.2a11.429,11.429,0,0,1,11.437,0l48.2,27.83a11.653,11.653,0,0,1,5.256,9.1",
    transform: "translate(18.032 95.564)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276026",
    "data-name": "Path 276026",
    d: "M99.171,58.364l-4.279-2.471a10.865,10.865,0,0,0-10.143-.168l-69.232,39.9c-.308.179-.644.413-.539.336a12.032,12.032,0,0,0-4.662,7.879c.388-2.683,2.573-3.652,5.2-2.149l4.285,2.474a11.618,11.618,0,0,0,10.512,0L99.171,64.432c2.9-1.676,2.9-4.392,0-6.068",
    transform: "translate(18.071 95.563)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276027",
    "data-name": "Path 276027",
    d: "M118.349,105.385v50.481a11.653,11.653,0,0,1-5.256,9.1l-4.285,2.477-.072.036a11.228,11.228,0,0,1-6.156,1.167,10.333,10.333,0,0,1-4.285-1.2l-48.648-28.1a11.657,11.657,0,0,1-5.253-9.1V79.763a11.62,11.62,0,0,1,5.253-9.1l3.811-2.2a11.429,11.429,0,0,1,11.437,0l48.2,27.83a11.653,11.653,0,0,1,5.256,9.1",
    transform: "translate(77.775 117.237)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276028",
    "data-name": "Path 276028",
    d: "M51.506,68.452l-3.82,2.207c-2.9,1.668-2.9,4.4,0,6.068L96.34,104.818a11.659,11.659,0,0,1,5.253,9.1v50.486c0,3.338,2.367,4.7,5.253,3.035l4.282-2.471a11.661,11.661,0,0,0,5.259-9.1V105.38a11.661,11.661,0,0,0-5.259-9.1L62.934,68.452a11.427,11.427,0,0,0-11.429,0",
    transform: "translate(79.737 117.237)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276029",
    "data-name": "Path 276029",
    d: "M66.876,92.732v50.486c0,3.338,2.364,4.706,5.256,3.035l4.279-2.471a11.654,11.654,0,0,0,5.256-9.1V84.193a10.765,10.765,0,0,0-1.544-5.179L65.332,87.556a10.755,10.755,0,0,1,1.544,5.176",
    transform: "translate(114.454 138.424)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276030",
    "data-name": "Path 276030",
    d: "M140.832,130.584a12.507,12.507,0,0,1-1.921,2.892,22.949,22.949,0,0,1-4.942,3.456c-18.487,10.68-31.817,18.344-50.307,29.019a5.809,5.809,0,0,1-5.256,0L61.314,156.08,27.121,136.344a11.273,11.273,0,0,1-5.253-8.726,11.274,11.274,0,0,1,5.253-8.729l19.4-11.2,14.794-8.531L77.387,89.9a11.681,11.681,0,0,1,10.512,0L136.547,118a11.276,11.276,0,0,1,5.256,8.726,9.282,9.282,0,0,1-.971,3.861",
    transform: "translate(38.31 155.302)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276031",
    "data-name": "Path 276031",
    d: "M46,133.218l55.508-32.027c1.453-.837,2.628-.157,2.628,1.519v5.317a5.806,5.806,0,0,1-2.628,4.552L45.994,144.6c-1.45.837-2.625.157-2.625-1.519l0-5.314A5.809,5.809,0,0,1,46,133.218",
    transform: "translate(75.978 176.65)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276032",
    "data-name": "Path 276032",
    d: "M77.383,80.442l-50.26,28.988a11.613,11.613,0,0,0-5.253,9.1V129.17a11.62,11.62,0,0,0,5.256,9.1l48.653,28.089a11.618,11.618,0,0,0,10.512,0l50.258-28.986a11.62,11.62,0,0,0,5.256-9.1V117.637a11.616,11.616,0,0,0-5.256-9.1L87.9,80.442a11.618,11.618,0,0,0-10.512,0",
    transform: "translate(38.312 138.724)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276033",
    "data-name": "Path 276033",
    d: "M81.039,125.367V148.15a10.709,10.709,0,0,1-5.256-1.263L27.124,118.8a11.62,11.62,0,0,1-5.256-9.1V99.065A11.769,11.769,0,0,1,26.59,90.3c-2.356,1.69-2.174,4.164.534,5.729l48.659,28.089a10.763,10.763,0,0,0,5.256,1.249",
    transform: "translate(38.31 158.196)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276034",
    "data-name": "Path 276034",
    d: "M84.33,143.59,134.588,114.6c2.9-1.676,2.9-4.392,0-6.068L85.934,80.442a11.618,11.618,0,0,0-10.512,0L25.164,109.431c-2.9,1.676-2.9,4.395,0,6.071L73.818,143.59a11.618,11.618,0,0,0,10.512,0",
    transform: "translate(40.27 138.724)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276035",
    "data-name": "Path 276035",
    d: "M71.02,139.022c-.663-8.927,5.421-32,5.421-32L59.938,97.3s-.757,5.639-1.7,13.215-2.609,10.669-2.609,10.669-3.066,3.908-2.969,6.47,2.345,8.415,3.693,12.928,2.213,7.986,4.937,12.326c2.645,4.21,14.467,7.51,13.8,3.085-.922-6.148-3.335-9.7-4.078-16.974",
    transform: "translate(92.258 170.464)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276036",
    "data-name": "Path 276036",
    d: "M57.165,105.982c-.977-.05-2.08,1.64-2.889,2.876s-2.818,2.166-2.441,5.267,3.17,5.413,3.685,9.648.726,11.519,6.962,16.619,12.76,5.542,15.144,4.133a3.062,3.062,0,0,0,1.447-1.863,2.458,2.458,0,0,0-.388-1.97c-.726-1.566-1.406-3.154-2.017-4.769a66.764,66.764,0,0,1-3.162-10.149c-.446-2.246-.539-4.318-1.109-4.675a8.906,8.906,0,0,0-4.626-1.456c-2.438-.325-3.792-.239-4.161-.019-.5.294-.349,1-.394,1.527-.058.715-.118,1.431-.176,2.146a1.182,1.182,0,0,1-.107.479.405.405,0,0,1-.4.226c-.176-.036-.281-.215-.358-.377-1.161-2.444-1.574-5.163-2.24-7.788a27.061,27.061,0,0,0-1.659-4.667c-.424-.977-1.065-2.345-1.37-3.231a1.955,1.955,0,0,1-.047-1.425Z",
    transform: "translate(90.727 185.666)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276037",
    "data-name": "Path 276037",
    d: "M72.878,113.031s5.132,12.284,8.033,16.787a53.255,53.255,0,0,0,10.909,12.7c.993.812,3.187,2.259,4,2.914a1.518,1.518,0,0,1,.245,2.331c-1.406,1.907-8.5,3.539-13.033,1.23s-9.467-7.342-12.282-9.345c-1.406-1-2.733-1.962-3.707-2.672-.936-.682-.886-1.112-.784-2.265l-.476-1.841c-.743-3.792-6.445-12.095-6.445-12.095Z",
    transform: "translate(103.945 198.018)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276038",
    "data-name": "Path 276038",
    d: "M62.328,120.239c-.831.512-.784,2.532-.751,4.007s-1.092,3.382.977,5.724,5.68,2.661,8.5,5.859,7.13,9.076,15.157,9.745,13.652-2.669,14.819-5.182a3.084,3.084,0,0,0,.138-2.356c-.281-.8-.729-.982-1.439-1.4q-2.229-1.313-4.365-2.785a66.946,66.946,0,0,1-8.357-6.566c-1.64-1.6-2.895-3.253-3.564-3.225a8.916,8.916,0,0,0-4.637,1.423c-2.193,1.117-3.261,1.957-3.437,2.345-.242.523.275,1.018.539,1.481l1.073,1.869a1.176,1.176,0,0,1,.182.454.4.4,0,0,1-.2.416.593.593,0,0,1-.506-.107c-2.342-1.357-4.227-3.363-6.261-5.146a22.555,22.555,0,0,0-3.586-2.752c-.9-.564-2.058-1.145-2.961-1.712-.674-.421-.916-.594-1.018-.916Z",
    transform: "translate(107.394 210.646)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276039",
    "data-name": "Path 276039",
    d: "M121.389,152.784c.737-6.192,1.852-15.664,2.512-21.982,1.054-10.083,1.571-20.559-.449-24.957-1.913-4.164-11.057-9.222-20.678-14.384S76.134,78.3,76.134,78.3L27.409,88.514c1.563,8.476,2.237,12.634,6.91,20.028C38.843,115.7,44.883,120.086,56.54,125.4c10.46,4.769,22.821,9.832,25.56,11.043,3.47,1.533,6.7,2.686,8.534,7.87,1.75,4.937,4.213,13.605,11.079,23.752,7.868,11.618,14.874,21.952,14.874,21.952s11.674.674,17.452-8.79c0,0-6.082-13.8-12.65-28.446",
    transform: "translate(48.018 137.171)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87607",
    "data-name": "Group 87607",
    transform: "translate(75.427 215.47)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87606",
    "data-name": "Group 87606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87605",
    "data-name": "Group 87605",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276040",
    "data-name": "Path 276040",
    d: "M121.389,152.784c.737-6.192,1.852-15.664,2.512-21.982,1.054-10.083,1.571-20.559-.449-24.957-1.913-4.164-11.057-9.222-20.678-14.384S76.134,78.3,76.134,78.3L27.409,88.514c1.563,8.476,2.237,12.634,6.91,20.028C38.843,115.7,44.883,120.086,56.54,125.4c10.46,4.769,22.821,9.832,25.56,11.043,3.47,1.533,6.7,2.686,8.534,7.87,1.75,4.937,4.213,13.605,11.079,23.752,7.868,11.618,14.874,21.952,14.874,21.952s11.674.674,17.452-8.79c0,0-6.082-13.8-12.65-28.446",
    transform: "translate(-27.409 -78.299)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87610",
    "data-name": "Group 87610",
    transform: "translate(120.496 224.312)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87609",
    "data-name": "Group 87609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87608",
    "data-name": "Group 87608",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276041",
    "data-name": "Path 276041",
    d: "M91.144,143.7c-6.175-13.729-12.386-27.3-14.079-30.186C73.458,107.4,44.709,91.394,43.8,90.89l-.017-.011,1.189-1.94a18.624,18.624,0,0,0,2.273-7.427,19.825,19.825,0,0,1-.743,8.322c4.425,2.568,15.68,9.1,20.2,11.9,5.68,3.52,11.748,7.818,14.527,14.28,2.053,4.794,7.326,20.083,9.912,27.684",
    transform: "translate(-43.786 -81.512)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276042",
    "data-name": "Path 276042",
    d: "M58.6,123.01l2.873,4.764s14,1.34,18.311-9.032l-2.163-4.753c-2,5.837-12.155,10.1-19.021,9.021",
    transform: "translate(102.654 199.696)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276043",
    "data-name": "Path 276043",
    d: "M36.471,58.266c10.942-1,13.633,3.432,16.286,7.818,4.494,7.427,12.9,31.088,12.9,31.088l31.768,14.4L91.869,121.9s-29.808-8.759-33.945-10.609c-2.565-1.145-3.974-1.924-5.889-5.41-3.795-6.918-9.841-20.105-9.841-20.105Z",
    transform: "translate(63.893 101.825)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276044",
    "data-name": "Path 276044",
    d: "M36.575,58.243c3.222-.509,7.986-.245,11.363,1.88s4.742,4.667,8.754,12.766,9.387,24.274,9.387,24.274l6.525,3.214c-2.749,1.167-7.686,9.945-6.561,13.836,0,0-7.174-2.273-9.824-3.09s-3.319-2.628-5.471-6.571-9.012-18.928-9.012-18.928-6.417-26.889-5.16-27.381",
    transform: "translate(63.789 101.647)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87613",
    "data-name": "Group 87613",
    transform: "translate(100.2 159.669)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87612",
    "data-name": "Group 87612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87611",
    "data-name": "Group 87611",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276045",
    "data-name": "Path 276045",
    d: "M36.575,58.243c3.222-.509,7.986-.245,11.363,1.88s4.742,4.667,8.754,12.766,9.387,24.274,9.387,24.274l6.525,3.214c-2.749,1.167-7.686,9.945-6.561,13.836,0,0-7.174-2.273-9.824-3.09s-3.319-2.628-5.471-6.571-9.012-18.928-9.012-18.928-6.417-26.889-5.16-27.381",
    transform: "translate(-36.411 -58.022)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87616",
    "data-name": "Group 87616",
    transform: "translate(121.358 197.387)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87615",
    "data-name": "Group 87615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87614",
    "data-name": "Group 87614",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276046",
    "data-name": "Path 276046",
    d: "M52.609,73.151c-1.571-.38-5.873.715-8.509,2.537,0,0,2.02-3.36,8.027-3.96Z",
    transform: "translate(-44.1 -71.728)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276047",
    "data-name": "Path 276047",
    d: "M36.8,62.111,25.6,66.393c-2.213,1.015,1.794,14.285,2.779,29.844,1.01,15.98,4.051,36.1,4.051,36.1s12.411,3.426,30.254-4.309c15.788-6.847,17.766-14.346,17.766-14.346l-4.959-6.921L73.75,92.179s5.732-8.08.93-17.122C69.927,66.107,56.666,58.1,56.666,58.1l-5.892.911Z",
    transform: "translate(43.698 101.788)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87619",
    "data-name": "Group 87619",
    transform: "translate(68.642 159.891)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87618",
    "data-name": "Group 87618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87617",
    "data-name": "Group 87617",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276048",
    "data-name": "Path 276048",
    d: "M36.8,62.111,25.6,66.393c-2.213,1.015,1.794,14.285,2.779,29.844,1.01,15.98,4.051,36.1,4.051,36.1s12.411,3.426,30.254-4.309c15.788-6.847,17.766-14.346,17.766-14.346l-4.959-6.921L73.75,92.179s5.732-8.08.93-17.122C69.927,66.107,56.666,58.1,56.666,58.1l-5.892.911Z",
    transform: "translate(-24.944 -58.103)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87622",
    "data-name": "Group 87622",
    transform: "translate(84.763 195.836)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87621",
    "data-name": "Group 87621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87620",
    "data-name": "Group 87620",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276049",
    "data-name": "Path 276049",
    d: "M30.8,74.007a12.912,12.912,0,0,0,11.877,4.381,12.746,12.746,0,0,0,9.508-7.224s-.487,8.113-10.025,9.293-11.36-6.45-11.36-6.45",
    transform: "translate(-30.801 -71.165)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276050",
    "data-name": "Path 276050",
    d: "M57.674,44.323c2.529,1.4,5.776,7.581,5.831,20.716.044,11.131-3.487,13.977-5.275,14.819s-5.295.454-8.7-.019l.061,4.609c4.631,6.9,6.186,11.423,8.157,18.05-8.792-6.621-11.85-8.924-22.89-15.017l-.33-15.43s-1.946,2-5.413-.875c-2.865-2.369-3.919-6.467-1.8-8.737A4.872,4.872,0,0,1,35.1,63.771s-1.541-13.382,5.562-17.538,16.649,2.416,17.009-1.91",
    transform: "translate(45.885 77.649)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276051",
    "data-name": "Path 276051",
    d: "M34.786,54.27l3.569.938a1.813,1.813,0,0,1-2.218,1.376,1.931,1.931,0,0,1-1.351-2.314",
    transform: "translate(60.85 95.075)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276052",
    "data-name": "Path 276052",
    d: "M41.27,49.874,37.649,49a1.787,1.787,0,0,1,2.182-1.4,1.957,1.957,0,0,1,1.439,2.279",
    transform: "translate(65.957 83.29)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276053",
    "data-name": "Path 276053",
    d: "M33.205,51.1l3.206-1.9a1.788,1.788,0,0,0-2.5-.7,1.958,1.958,0,0,0-.7,2.6",
    transform: "translate(57.761 84.522)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276054",
    "data-name": "Path 276054",
    d: "M40.783,51.179a1.514,1.514,0,1,1-1.668-1.414,1.539,1.539,0,0,1,1.668,1.414",
    transform: "translate(66.158 87.169)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276055",
    "data-name": "Path 276055",
    d: "M36.525,51.632a1.514,1.514,0,1,1-1.668-1.414,1.539,1.539,0,0,1,1.668,1.414",
    transform: "translate(58.698 87.963)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276056",
    "data-name": "Path 276056",
    d: "M42.46,60.517c-3.591-.372-11.008-2.287-12.235-5.165A7.533,7.533,0,0,0,32.908,59c2.248,1.825,9.612,3.748,9.612,3.748Z",
    transform: "translate(52.951 96.971)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276057",
    "data-name": "Path 276057",
    d: "M34.983,50.991a.4.4,0,0,0-.226-.154c-.162-.063-.325-.113-.49-.165-.215-.069-.429-.14-.644-.212-.182-.061-.366-.118-.553-.165a2.4,2.4,0,0,0-.347-.063,1.208,1.208,0,0,0-.454.039c-.118.03-.135.184-.107.278a.394.394,0,0,0,.27.264c.088.019.173.058.264.072l.182.033.074.016.039.008q.083.017.165.041c.2.05.385.113.578.171a3.343,3.343,0,0,0,.765.171.747.747,0,0,0,.38-.066.208.208,0,0,0,.1-.267",
    transform: "translate(56.325 87.987)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276058",
    "data-name": "Path 276058",
    d: "M34.893,51.15a.785.785,0,0,0-.556-.3,4.824,4.824,0,0,0-.936-.03c-.355.019-.713.039-1.068.077s-.129.545.129.57a8.657,8.657,0,0,0,1.332-.052,4.992,4.992,0,0,1,.537-.017h.242a.821.821,0,0,0,.162-.022c.094-.025.085-.036.149-.1a.108.108,0,0,0,.008-.127",
    transform: "translate(56.33 89.009)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276059",
    "data-name": "Path 276059",
    d: "M34.433,51.238c-.091-.085-.228-.036-.333-.014a1.693,1.693,0,0,0-.231.063c-.157.058-.314.11-.473.162s-.3.094-.449.138l-.184.05a2.5,2.5,0,0,0-.239.088.182.182,0,0,0-.124.187l0,.047a.317.317,0,0,0,.16.253.448.448,0,0,0,.215.036l.063-.011c.072-.014.14-.017.209-.036l.242-.069c.157-.05.314-.1.471-.157a1.618,1.618,0,0,0,.561-.305.481.481,0,0,0,.135-.187.244.244,0,0,0-.025-.245",
    transform: "translate(56.759 89.678)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276060",
    "data-name": "Path 276060",
    d: "M67.018,64.141a.094.094,0,0,0-.008-.047c-.63-3.531-1.332-6.164-1.494-6.775a1.212,1.212,0,0,0-.039-.124c-.011,8.165-10.73,7.763-10.73,7.763,2.009-5.358-.669-7.524-.669-7.524-2.711,6.943-8.1,8.19-8.1,8.19-.008-4.909-2.13-7.3-2.13-7.3C44.89,66.92,39.106,70.82,39.106,70.82a4.872,4.872,0,0,0-7.793-1.332c-2.119,2.273-1.065,6.373,1.8,8.743,3.473,2.865,5.413.875,5.413.875l.171,8.038C38.25,83.349,24.6,74.5,23.97,63.723,23.359,53.2,27,46.276,38.211,41.622c9.97-4.147,19.236,2.768,19.236,2.768,5.432-.361,10.2,3.1,11.921,9.172a11.961,11.961,0,0,1-2.35,10.578",
    transform: "translate(41.88 70.597)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276061",
    "data-name": "Path 276061",
    d: "M37.6,46.85a13.427,13.427,0,0,1-10.132,9.838,5.243,5.243,0,0,1,5.385,2.653S39.346,56.815,37.6,46.85",
    transform: "translate(48.128 82.076)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276062",
    "data-name": "Path 276062",
    d: "M57.312,48.436c-.231,0-.473.006-.721.014A21.334,21.334,0,0,0,49.422,49.7c-2.265,1.037-3.046,1.951-4.315,2.135-1.354.187-2.24-.493-4.706-.864a23.933,23.933,0,0,0-7.678.848q-.4.1-.768.2a1.415,1.415,0,0,0-.809,1.425,2.611,2.611,0,0,0,.787,1.414,1.714,1.714,0,0,1,.272.578,25.214,25.214,0,0,0,1.079,4.059,4.594,4.594,0,0,0,1.032,1.368,3.7,3.7,0,0,0,.517.374c.1.055.193.107.294.157a3.983,3.983,0,0,0,.875.3c.05.011.1.019.146.028.074.014.154.028.231.039l.242.025a5.345,5.345,0,0,0,.765.017c.1,0,.215-.011.327-.019.129-.014.267-.028.407-.047a5.943,5.943,0,0,0,5.141-3.855c.732-1.7.454-3.913,1.9-4.114a1.3,1.3,0,0,1,.14-.011,1.006,1.006,0,0,1,.129,0c1.081.107,1.018,2.182,1.745,3.572A5.361,5.361,0,0,0,48.266,58.8c.083.074.165.146.253.215.044.036.091.069.135.1s.094.063.143.094.083.055.127.08c.077.041.107.061.14.077s.072.036.11.052a.669.669,0,0,0,.077.039,4.1,4.1,0,0,0,1.271.338.784.784,0,0,0,.116.011,6.353,6.353,0,0,0,1.541-.058,5.074,5.074,0,0,0,4.348-3.536,29.361,29.361,0,0,0,.76-4.32,1.482,1.482,0,0,1,.248-.589,3.229,3.229,0,0,0,.614-1.637c.014-.677-.438-1.23-.837-1.23M42.4,56.5a5.391,5.391,0,0,1-1.018,2.367l0,0a4.881,4.881,0,0,1-3.39,1.745,3.438,3.438,0,0,1-3.355-1.148c-.041-.05-.077-.1-.11-.143a1.564,1.564,0,0,1-.1-.146c-.03-.044-.061-.088-.088-.135l-.072-.124c-.019-.033-.036-.066-.052-.1a.711.711,0,0,1-.047-.091c-.025-.05-.05-.1-.072-.149l0,0c-.069-.149-.129-.3-.179-.44l-.006-.011c-.03-.091-.061-.182-.091-.267-.05-.157-.088-.3-.121-.435-.008-.028-.017-.055-.022-.083l-.022-.08c-.281-1.076-.644-3.217-.118-3.784.506-.548,1.94-1.282,4.293-1.376a2.464,2.464,0,0,1,.25-.011,8.815,8.815,0,0,1,1.079.039c.14.011.281.028.418.044a9.312,9.312,0,0,1,1.054.2c.113.03.223.061.325.094.124.036.242.077.352.118a.547.547,0,0,0,.072.028c.044.017.085.036.127.055a1.907,1.907,0,0,1,.724.484c.49.614.4,2.075.176,3.346m13.66-2.4a5.443,5.443,0,0,1-2.094,3.866,4.378,4.378,0,0,1-1.731.638,3.439,3.439,0,0,1-3.564-1.17l-.008-.017c-.025-.03-.047-.061-.069-.091s-.052-.074-.074-.11l-.039-.055c-.033-.055-.066-.11-.1-.165s-.066-.124-.1-.19l-.047-.094-.022-.055-.036-.08-.025-.061a5.117,5.117,0,0,1-.253-.8,5.5,5.5,0,0,1-.041-3.366c.421-.746,2.124-1.736,3.781-2.182a9.951,9.951,0,0,1,1.076-.234c.044-.008.085-.014.127-.019s.094-.014.138-.019c.129-.019.253-.03.374-.044l.138-.011.176-.008c.1-.006.2-.008.294-.006a4.844,4.844,0,0,1,.542.022l.129.014.033.005.088.011.132.019c.052.008.107.022.157.033a2.075,2.075,0,0,1,.259.069l.044.014a1.817,1.817,0,0,1,.592.294c.52.418.311,2.642.118,3.784",
    transform: "translate(54.558 84.855)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276063",
    "data-name": "Path 276063",
    d: "M35.773,49.954,28.979,52.4a6.711,6.711,0,0,1,1.241,1.5l5.647-1.822Z",
    transform: "translate(50.768 87.514)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276064",
    "data-name": "Path 276064",
    d: "M36.034,50.6l1.183,8.726,5.091-1.929-5.787-7.015a1.138,1.138,0,0,0-.487.217",
    transform: "translate(63.128 88.257)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276065",
    "data-name": "Path 276065",
    d: "M48.281,83.326l3.806,4.645a.182.182,0,0,1-.182.294l-5.881-1.379Z",
    transform: "translate(80.629 145.978)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276066",
    "data-name": "Path 276066",
    d: "M48.962,85.884a.182.182,0,0,0,.182-.294l-.743-.905a1.01,1.01,0,0,1-.6.864l-.094.041Z",
    transform: "translate(83.572 148.357)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276067",
    "data-name": "Path 276067",
    d: "M38.209,82.03l.473.294.567.355L59.715,95.421a2.683,2.683,0,0,0,1.643-1.07,2.753,2.753,0,0,0,.614-2.488L41.517,79.13l-1.087-.677c.68.479-1.533,4.048-2.221,3.577",
    transform: "translate(66.938 137.441)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276068",
    "data-name": "Path 276068",
    d: "M38.86,82.446l1.054.655c.3.2.9-.33,1.436-1.04.713-.941,1.17-2.284.773-2.551l-.776-.482-.281-.171c.4.267-.061,1.613-.773,2.551-.515.68-1.092,1.194-1.4,1.054H38.89l-.03-.016",
    transform: "translate(68.078 138.151)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276069",
    "data-name": "Path 276069",
    d: "M39.627,82.923c.693.465,2.9-3.123,2.207-3.588l-1.054-.658c.693.465-1.511,4.054-2.207,3.588Z",
    transform: "translate(67.576 137.833)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276070",
    "data-name": "Path 276070",
    d: "M38.209,82.03l1.04.649c.68.462,2.837-2.98,2.268-3.55l-.036-.03-1.051-.647c.68.479-1.533,4.048-2.221,3.577",
    transform: "translate(66.938 137.441)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87625",
    "data-name": "Group 87625",
    transform: "translate(105.146 217.715)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87624",
    "data-name": "Group 87624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87623",
    "data-name": "Group 87623",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276071",
    "data-name": "Path 276071",
    d: "M65.783,95.571l-.006-.223-4.084-2.661L40.047,79.217c.041-.066.028-.1-.025-.1-.567,1.018-1.428,2.02-1.813,1.756l.471.294.57.358L59.715,94.264,65.6,95.64a.175.175,0,0,0,.187-.069",
    transform: "translate(-38.208 -79.115)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276072",
    "data-name": "Path 276072",
    d: "M36.832,81.105l4.417,2.755c.294.2.892-.319,1.425-1.021.715-.938,1.183-2.284.793-2.557l0,0-4.431-2.763c-.886-.548-2.215,1.106-2.51,2.405a1.077,1.077,0,0,0,.308,1.183",
    transform: "translate(63.898 135.612)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87628",
    "data-name": "Group 87628",
    transform: "translate(100.373 213.022)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87627",
    "data-name": "Group 87627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87626",
    "data-name": "Group 87626",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276073",
    "data-name": "Path 276073",
    d: "M38.194,80.678A3.263,3.263,0,0,0,39.286,78a.734.734,0,0,0-.4-.553c-.875-.3-2.08,1.247-2.361,2.474a1.09,1.09,0,0,0,.289,1.167c.336.2.856.072,1.381-.41",
    transform: "translate(-36.475 -77.409)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276074",
    "data-name": "Path 276074",
    d: "M41.877,80.319a4.108,4.108,0,0,1,3.564.8c1.156.724,2.843.842,2.978,1.42s-.674,1.428-.674,1.428Z",
    transform: "translate(73.364 140.479)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276075",
    "data-name": "Path 276075",
    d: "M41.059,97.082c2.463-.228,10.427-.407,13.025-.974a10.651,10.651,0,0,0,5.867-3.283c.377-.435.718-.9,1.084-1.34a3.386,3.386,0,0,1,.977-.971c.325-.173.674-.3.991-.487a2.893,2.893,0,0,0,1.376-2.171,3.523,3.523,0,0,1,.061-.537.671.671,0,0,1,.294-.432.952.952,0,0,1,.556-.055,8.232,8.232,0,0,0,2.091.11,3.917,3.917,0,0,0,1.481-.5c.338-.212.958-.85.394-1.189-.754-.454-1.489-.944-2.086-1.225-3.145-1.481-5.776-1.764-9.238-2.069-1.6-.14-3.833-.138-5.427-.245-.685-.044-1.409-.182-2.124-.264l-1.04-.649a4.485,4.485,0,0,0-1.871.66c-.914.537-1.924,1.4-2.856,1.9-2.369,1.263-6.693,1.31-10.11,1.181",
    transform: "translate(60.442 141.556)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276076",
    "data-name": "Path 276076",
    d: "M78.711,72.121,52.675,84.5l-6.792,30.43L48.1,117.2l24.481-12.45,8.346-30.362Z",
    transform: "translate(80.383 126.349)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276077",
    "data-name": "Path 276077",
    d: "M54.893,78.884,48.1,109.315l-2.218-2.265,6.792-30.43Z",
    transform: "translate(80.383 134.229)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276078",
    "data-name": "Path 276078",
    d: "M80.143,72.719,53.535,85.377l-7.017,31.171.693.735,25.081-12.727,8.542-31.1Z",
    transform: "translate(81.495 127.395)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87631",
    "data-name": "Group 87631",
    transform: "translate(128.014 200.114)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87630",
    "data-name": "Group 87630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87629",
    "data-name": "Group 87629",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276079",
    "data-name": "Path 276079",
    d: "M80.143,72.719,53.535,85.377l-7.017,31.171.693.735,25.081-12.727,8.542-31.1Z",
    transform: "translate(-46.519 -72.719)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276080",
    "data-name": "Path 276080",
    d: "M54.227,78.054l-7.017,31.171-.691-.735,7.017-31.171Z",
    transform: "translate(81.495 135.454)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87634",
    "data-name": "Group 87634",
    transform: "translate(128.014 212.772)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87633",
    "data-name": "Group 87633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87632",
    "data-name": "Group 87632",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276081",
    "data-name": "Path 276081",
    d: "M54.227,78.054l-7.017,31.171-.691-.735,7.017-31.171Z",
    transform: "translate(-46.518 -77.318)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276082",
    "data-name": "Path 276082",
    d: "M80.395,72.986,53.786,85.645l-7.017,31.171,25.083-12.73Z",
    transform: "translate(81.934 127.864)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87637",
    "data-name": "Group 87637",
    transform: "translate(148.8 224.396)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87636",
    "data-name": "Group 87636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87635",
    "data-name": "Group 87635",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276083",
    "data-name": "Path 276083",
    d: "M54.072,81.644c.3.765,2.81,2.449,6.445,2.149l.614-2.251Z",
    transform: "translate(-54.071 -81.543)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87640",
    "data-name": "Group 87640",
    transform: "translate(136.812 213.887)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87639",
    "data-name": "Group 87639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87638",
    "data-name": "Group 87638",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276084",
    "data-name": "Path 276084",
    d: "M49.751,78.776c-.113.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.747,1.747,0,0,0-.768,1",
    transform: "translate(-49.717 -77.724)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276085",
    "data-name": "Path 276085",
    d: "M51.977,76.063a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.084,5.084,0,0,0-.1,1.4l.52-.25a4.863,4.863,0,0,1,.1-1.037,1.619,1.619,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.666,2.666,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.14,1.14,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.193,1.193,0,0,0,.22.022,1.526,1.526,0,0,0,.385-.05,2.038,2.038,0,0,0,.264-.107,2.294,2.294,0,0,0,1.04-1.61,6.534,6.534,0,0,0-1.475-5.372",
    transform: "translate(85.274 131.938)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87643",
    "data-name": "Group 87643",
    transform: "translate(140.469 212.146)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87642",
    "data-name": "Group 87642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87641",
    "data-name": "Group 87641",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276086",
    "data-name": "Path 276086",
    d: "M51.079,78.143c-.11.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.747,1.747,0,0,0-.768,1",
    transform: "translate(-51.044 -77.092)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276087",
    "data-name": "Path 276087",
    d: "M53.3,75.43a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.084,5.084,0,0,0-.1,1.4l.52-.25a4.864,4.864,0,0,1,.1-1.037,1.614,1.614,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.664,2.664,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.14,1.14,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.194,1.194,0,0,0,.22.022,1.541,1.541,0,0,0,.385-.05,2.042,2.042,0,0,0,.264-.107,2.294,2.294,0,0,0,1.04-1.61A6.534,6.534,0,0,0,53.3,75.43",
    transform: "translate(87.6 130.829)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87646",
    "data-name": "Group 87646",
    transform: "translate(144.125 210.405)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87645",
    "data-name": "Group 87645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87644",
    "data-name": "Group 87644",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276088",
    "data-name": "Path 276088",
    d: "M52.409,77.511c-.113.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.736,1.736,0,0,0-.768,1",
    transform: "translate(-52.373 -76.458)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276089",
    "data-name": "Path 276089",
    d: "M54.634,74.8a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.083,5.083,0,0,0-.1,1.4l.52-.25a4.88,4.88,0,0,1,.1-1.037,1.619,1.619,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.664,2.664,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.14,1.14,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.191,1.191,0,0,0,.22.022,1.411,1.411,0,0,0,.385-.05,2.042,2.042,0,0,0,.264-.107,2.3,2.3,0,0,0,1.04-1.61A6.534,6.534,0,0,0,54.634,74.8",
    transform: "translate(89.929 129.72)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87649",
    "data-name": "Group 87649",
    transform: "translate(147.781 208.664)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87648",
    "data-name": "Group 87648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87647",
    "data-name": "Group 87647",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276090",
    "data-name": "Path 276090",
    d: "M53.738,76.878c-.113.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.736,1.736,0,0,0-.768,1",
    transform: "translate(-53.701 -75.826)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276091",
    "data-name": "Path 276091",
    d: "M55.963,74.164a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.083,5.083,0,0,0-.1,1.4l.52-.25a4.881,4.881,0,0,1,.1-1.037,1.619,1.619,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.665,2.665,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.14,1.14,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.2,1.2,0,0,0,.22.022,1.411,1.411,0,0,0,.385-.05,2.046,2.046,0,0,0,.264-.107,2.294,2.294,0,0,0,1.04-1.61,6.534,6.534,0,0,0-1.475-5.372",
    transform: "translate(92.257 128.611)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87652",
    "data-name": "Group 87652",
    transform: "translate(151.438 206.923)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87651",
    "data-name": "Group 87651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87650",
    "data-name": "Group 87650",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276092",
    "data-name": "Path 276092",
    d: "M55.065,76.245c-.11.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.747,1.747,0,0,0-.768,1",
    transform: "translate(-55.031 -75.194)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276093",
    "data-name": "Path 276093",
    d: "M57.291,73.532a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.083,5.083,0,0,0-.1,1.4l.52-.25a4.864,4.864,0,0,1,.1-1.037,1.619,1.619,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879A2.666,2.666,0,0,1,58,79.5a1.2,1.2,0,0,1-.677.611.749.749,0,0,1-.283.03,1.139,1.139,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.2,1.2,0,0,0,.22.022,1.525,1.525,0,0,0,.385-.05,2.036,2.036,0,0,0,.264-.107,2.3,2.3,0,0,0,1.04-1.61,6.534,6.534,0,0,0-1.475-5.372",
    transform: "translate(94.583 127.504)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87655",
    "data-name": "Group 87655",
    transform: "translate(155.094 205.182)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87654",
    "data-name": "Group 87654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87653",
    "data-name": "Group 87653",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276094",
    "data-name": "Path 276094",
    d: "M56.394,75.612c-.11.407.052.616.363.468a1.725,1.725,0,0,0,.768-1.007c.113-.4-.05-.614-.363-.465a1.764,1.764,0,0,0-.768,1",
    transform: "translate(-56.359 -74.561)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276095",
    "data-name": "Path 276095",
    d: "M58.62,72.9a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.084,5.084,0,0,0-.1,1.4l.52-.25a4.863,4.863,0,0,1,.1-1.037,1.614,1.614,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.665,2.665,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.139,1.139,0,0,0-.143.333c-.014.063-.028.121-.036.179a1.2,1.2,0,0,0,.22.022,1.541,1.541,0,0,0,.385-.05,2.045,2.045,0,0,0,.264-.107,2.3,2.3,0,0,0,1.04-1.61A6.534,6.534,0,0,0,58.62,72.9",
    transform: "translate(96.912 126.395)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87658",
    "data-name": "Group 87658",
    transform: "translate(158.751 203.441)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87657",
    "data-name": "Group 87657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87656",
    "data-name": "Group 87656",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276096",
    "data-name": "Path 276096",
    d: "M57.724,74.98c-.113.4.052.614.363.465a1.727,1.727,0,0,0,.768-1c.113-.4-.05-.614-.363-.465a1.736,1.736,0,0,0-.768,1",
    transform: "translate(-57.688 -73.928)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276097",
    "data-name": "Path 276097",
    d: "M59.949,72.266a1.952,1.952,0,0,0-1.888-.7,2.1,2.1,0,0,0-1.3,1.717,5.084,5.084,0,0,0-.1,1.4l.52-.248a4.872,4.872,0,0,1,.1-1.04,1.619,1.619,0,0,1,.933-1.318,1.438,1.438,0,0,1,1.354.561,5.92,5.92,0,0,1,1.34,4.879,2.666,2.666,0,0,1-.25.707,1.2,1.2,0,0,1-.677.611.75.75,0,0,1-.283.03,1.14,1.14,0,0,0-.143.333c-.014.066-.028.121-.036.179a1.2,1.2,0,0,0,.22.022,1.525,1.525,0,0,0,.385-.05,2.042,2.042,0,0,0,.264-.107,2.294,2.294,0,0,0,1.04-1.61,6.534,6.534,0,0,0-1.475-5.372",
    transform: "translate(99.24 125.286)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276098",
    "data-name": "Path 276098",
    d: "M67.828,75.691s-1.164,4.271-1.464,5.355c-.715,2.592-5.666,3.553-8.349,3.888-5.135.638-5.718,1.753-4.483,5.4,1.139,3.363,4.483,4.629,9.117,4.084A8.392,8.392,0,0,0,69,88.867c1.5-4.3.693-8.883,1.291-11.39s-1.159-3.283-2.466-1.786",
    transform: "translate(92.819 131.27)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276099",
    "data-name": "Path 276099",
    d: "M82.8,202.966V152.48a11.654,11.654,0,0,0-5.256-9.1L28.829,115.255a3.459,3.459,0,0,1,0-5.994l1.186-.685L25.887,83.652A13.96,13.96,0,0,0,19.83,74.6l-4.279-2.471c-2.892-1.67-5.256-.3-5.256,3.033V97.337l.085,63.91a11.658,11.658,0,0,0,5.256,9.1L77.546,206c2.892,1.668,5.256.3,5.256-3.035",
    transform: "translate(18.036 125.12)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276100",
    "data-name": "Path 276100",
    d: "M86.895,122.242v50.494c0,.107,0,.228-.011.338a11.739,11.739,0,0,1-5.2,8.74.085.085,0,0,0-.05.025L77.368,184.3a2.139,2.139,0,0,1-.4.206,2.007,2.007,0,0,1-.217.11c-.025.011-.05.011-.061.022a3.572,3.572,0,0,1-.427.16,12.192,12.192,0,0,1-7.73.217,7.471,7.471,0,0,1-.911-.339c2.523,1.043,4.477-.377,4.491-3.4V130.787a11.653,11.653,0,0,0-5.256-9.1l-9.541-5.509L18.131,93.559a3.46,3.46,0,0,1,0-5.994l4.351-2.512a11.687,11.687,0,0,1,10.512,0L72.112,107.64l9.527,5.5a11.645,11.645,0,0,1,5.256,9.1",
    transform: "translate(28.729 146.816)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276101",
    "data-name": "Path 276101",
    d: "M39.5,109.61V160.1c-.011,3.022-1.965,4.442-4.491,3.4a7.468,7.468,0,0,0,.911.338,12.21,12.21,0,0,0,7.73-.217,4.122,4.122,0,0,0,.427-.16c.011-.011.036-.011.061-.022.072-.039.146-.063.217-.11a2.142,2.142,0,0,0,.4-.206l4.271-2.466a.11.11,0,0,1,.05-.022,11.739,11.739,0,0,0,5.2-8.74c.011-.11.011-.231.011-.341V101.066a10.766,10.766,0,0,0-1.538-5.174l-14.789,8.539A10.764,10.764,0,0,1,39.5,109.61",
    transform: "translate(61.337 167.992)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276102",
    "data-name": "Path 276102",
    d: "M60.2,119.032c-6.731-.256-22.056-2.375-22.056-2.375l3.4-29.819c1.728-7.078-3.154-23.339-6.993-25.722-1.7.506-5.2,1.511-9.067,7.361-2.105,3.189-2.6,8.652-4.062,21.842-1.04,9.384-1.45,22.241-1.585,30.741-.151,9.458,3.69,12.048,12.232,12.557,14.288.848,29.085-1.53,34.685-2.047",
    transform: "translate(34.746 107.069)",
    fill: "#fdac45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276103",
    "data-name": "Path 276103",
    d: "M35.962,60.979c-5.578,1.373-7.769,3.2-10.5,7.738s-3.822,18.3-5.063,32.943-.883,23.193-.644,25.637,2.378,6.186,8.443,6.7a87.5,87.5,0,0,0,12.152.044s-1.167-10.617,3.322-16.487l-4.629-.848,4.318-32.58S42.985,67.3,35.962,60.979",
    transform: "translate(34.184 106.829)",
    fill: "#abacad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87661",
    "data-name": "Group 87661",
    transform: "translate(53.697 167.808)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87660",
    "data-name": "Group 87660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87659",
    "data-name": "Group 87659",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276104",
    "data-name": "Path 276104",
    d: "M35.962,60.979c-5.578,1.373-7.769,3.2-10.5,7.738s-3.822,18.3-5.063,32.943-.883,23.193-.644,25.637,2.378,6.186,8.443,6.7a87.5,87.5,0,0,0,12.152.044s-1.167-10.617,3.322-16.487l-4.629-.848,4.318-32.58S42.985,67.3,35.962,60.979",
    transform: "translate(-19.513 -60.98)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87664",
    "data-name": "Group 87664",
    transform: "translate(63.015 221.294)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87663",
    "data-name": "Group 87663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87662",
    "data-name": "Group 87662",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276105",
    "data-name": "Path 276105",
    d: "M33.106,82.652A19.624,19.624,0,0,0,22.9,84.658s2.179-3.539,10.5-4.243Z",
    transform: "translate(-22.898 -80.415)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276106",
    "data-name": "Path 276106",
    d: "M46.383,80.769a3.857,3.857,0,0,0,2.892-5.862c-.87-1.216-2.474-1.7-3.781-2.265a5.35,5.35,0,0,1-2.144-1.3c-1.3-1.676.46-3.3,1.731-4.169,1.6-1.087,3.5-1.816,4.719-3.374a6.248,6.248,0,0,0,1.293-4.411c-.341-3.811-3.566-5.482-6.726-6.849-4.428-1.913-8.817-3.767-10.831-8.506-2.2-5.168.592-11.72,5.16-14.593a12.038,12.038,0,0,1,15.292,2.188c3.9,4.175,5.473,10.829,3.143,16.156-4.686,10.71-23.1,7.672-26.085-2.873a16.533,16.533,0,0,1,4.315-15.939,15.342,15.342,0,0,1,13.319-3.839A15.106,15.106,0,0,1,60.035,36.174a25.835,25.835,0,0,1,.955,8.586,12.394,12.394,0,0,1-4.194,7.87,17.652,17.652,0,0,1-15.166,4.4,17.47,17.47,0,0,1-12.139-9.709c-3.418-7.92-1.161-19.15,7.105-23.176,5.76-2.807,11.968-3.322,17.414.454a23,23,0,0,1,9.312,12.65,17.047,17.047,0,0,1-3.916,16.225,19.846,19.846,0,0,1-13.358,5.87,19.482,19.482,0,0,1-13.261-3.976c-4.309-3.484-6.671-9.056-7.149-14.483-.9-10.207,4.9-18.595,14.12-22.593,9.733-4.221,20.9-3.366,30.953-.713,10.589,2.8,20.735,7.408,30.342,12.606,5.083,2.752,10.039,5.691,15.262,8.179a142.131,142.131,0,0,0,14.42,5.958c8.85,3.082,18.05,5.256,27.458,5.251a67.887,67.887,0,0,0,26.077-4.764,43.574,43.574,0,0,0,19.137-15.058c2.223-3.195,4.2-6.574,3.954-10.6-.217-3.487-2.4-6.189-6.106-5.917-4.414.322-6.849,4.439-8.773,7.917l.542.124c-1.494-2.713-3.145-5.716-5.963-7.259-2.138-1.172-5.146-1.39-7.122.231-4.53,3.71-1.3,11.1,1.442,14.833,6.453,8.787,17.241,13.982,27.324,17.3,14.458,4.761,30.177,6.61,45.192,3.6,12.953-2.6,24.745-8.624,36.278-14.841,6.838-3.688,13.63-7.546,20.777-10.614,7.689-3.3,16.489-5.886,24.775-3.222,7,2.248,13.6,9.61,11.613,17.414-1.684,6.61-9.9,11.3-15.947,7.127-5.143-3.55-13.74-15.584-4.065-19.046,6.12-2.191,14.178,1.1,18.746,5.187,2.683,2.4,4.725,5.9,3.2,9.522-1.478,3.509-5.63,5.094-9.191,5.248-7.628.325-15.551-5.028-15.691-13.14a11.418,11.418,0,0,1,4.144-9.266c2.942-2.3,6.814-2.837,10.435-2.43,7.215.806,14.943,5.174,18.454,11.676,3.311,6.134,2.058,15.075-4.717,18.292-6.1,2.895-14.417,1.6-20.469-.828-6.131-2.466-11.715-7.119-13.6-13.655-2.111-7.323,1.72-15.895,10.278-15.276,7.975.578,14.937,7.725,16.506,15.35,1.447,7.026-2.218,15.229-9.307,17.579-6.514,2.157-15.2-1.874-15.355-9.359-.138-6.742,6.836-13.349,13.355-9.158,2.807,1.808,4.851,5.3,4.1,8.7-.76,3.451-4.879,6.7-8.187,4.2a7.541,7.541,0,0,1-2.394-7.526c.85-3.41,4.436-5.223,7.694-5.534a15.092,15.092,0,0,1,10.135,2.7c1.643,1.23,2.878,3.289,1.552,5.242-1.714,2.526-4.279.231-4.843-1.874a6.683,6.683,0,0,1,3.319-7.526c3.487-1.6,7.284,1.464,7.8,4.953.239,1.6-.182,3.476-1.869,4.056a4,4,0,0,1-4.5-1.684c-1.973-3.627,3.712-6.778,6.541-4.8,3.566,2.488,2.147,7.8-1.258,9.59a7.793,7.793,0,0,1-9.51-1.9,10.072,10.072,0,0,1-1.833-9.835,11.124,11.124,0,0,1,6.877-6.321c7.32-2.543,15.942,2.7,16.154,10.7.182,6.792-5.5,13.069-12.108,14.084-7.466,1.148-15.265-3.533-18.627-10.143A13.058,13.058,0,0,1,332,33.932c1.321-4.076,5.592-5.6,9.574-5.1a13.282,13.282,0,0,1,11.038,17.056c-1.128,3.69-3.718,5.941-6.478,8.44-2.342,2.124-4.455,4.733-4.2,8.093.2,2.647,1.948,4.048,4.263,4.97,1.164.465,3.451.991,3.467,2.59.019,1.582-1.9,2.182-3.085,2.678-2.025.85-4.125,1.937-3.85,4.48a4.26,4.26,0,0,0,3.99,3.891c.76.022.338-1.035-.261-1.051-2.5-.069-3.451-3.4-1.734-5,1.222-1.139,3.041-1.4,4.436-2.251,2.4-1.472,1.778-4.128-.5-5.33-1.687-.889-3.916-1.115-5.008-2.826-1.354-2.113-.462-5.052.941-6.913,2.614-3.47,6.591-5.46,8.418-9.577A14.5,14.5,0,0,0,345.406,28.9c-3.558-1.527-8.275-1.841-11.555.531-2.766,2-3.591,5.49-3.278,8.734.743,7.656,7.367,14.161,14.593,16.121a15.572,15.572,0,0,0,18.358-8.17,13.117,13.117,0,0,0-7.02-17.852c-6.442-2.683-15.333.515-16.96,7.763-1.456,6.481,3.894,14.059,10.95,12.7,3.324-.641,6.068-3.258,6-6.775-.052-2.865-1.965-5.845-5-6.15-2.766-.278-5.85,1.877-5.875,4.8-.019,2.623,2.631,4.5,5.1,4.442,3.184-.08,4.084-3.3,3.324-5.955a7.658,7.658,0,0,0-6.461-5.578c-6.134-.363-8.938,8.869-4.012,12.276,2.59,1.791,5.366-.859,4.918-3.657-.531-3.341-4.474-5.2-7.342-6.057-5.972-1.794-15.309.154-14.6,8.074a8.179,8.179,0,0,0,3.916,6.514c2.906,1.527,6.211-.132,7.785-2.785,3.511-5.919-2.424-13.691-8.817-13.622-6.918.074-11.162,8.382-8.974,14.453,2.364,6.563,10.765,9.53,17,6.915,7.306-3.066,10.545-11.811,8.567-19.175-2.025-7.535-8.916-14.351-16.842-15.2a10.34,10.34,0,0,0-9.912,4.232,14.094,14.094,0,0,0-1.775,10.573c1.459,7.221,7.268,12.609,13.806,15.466A33.452,33.452,0,0,0,342.062,54.2c4.031.319,8.545.107,12.111-1.992,6.492-3.822,7.251-12.923,3.842-19.04-3.8-6.808-11.836-11.407-19.489-12.163-3.825-.377-7.928.308-10.922,2.87a12.139,12.139,0,0,0-4,9.706c.292,7.923,7.367,13.509,14.934,14.013,3.509.234,7.416-.663,9.926-3.272a7.738,7.738,0,0,0,1.115-9.067c-3.269-6.239-11.9-10.006-18.7-9.923-3.024.039-6.211.985-7.8,3.762-2.025,3.539-.347,7.628,1.759,10.7,2.188,3.192,5.223,6.907,9.045,8.115a10.637,10.637,0,0,0,9.175-1.731c6.445-4.519,6.621-12.92,2.163-18.93-5.416-7.3-14.827-8.883-23.311-7.237-9.816,1.9-18.87,7.185-27.568,11.88-7.226,3.9-14.417,7.9-21.946,11.192a87.989,87.989,0,0,1-24.222,6.984,86.786,86.786,0,0,1-29.511-1.742,83.346,83.346,0,0,1-24.874-9.359c-5.107-3.049-10.171-7.009-13.239-12.2-2.02-3.421-3.987-10.644,1.1-12.56,5.212-1.962,8.757,3.509,10.864,7.326.107.2.394.4.542.124,1.436-2.6,3.013-5.482,5.751-6.907,2.419-1.258,6.027-1.109,7.339,1.637,2.372,4.959-1.489,10.625-4.406,14.392-5.793,7.491-14.092,12.5-23.083,15.218A70.136,70.136,0,0,1,148.106,48.1c-11.484-1.775-22.629-5.955-33.031-11.038-5.8-2.834-11.294-6.211-17.026-9.172a163.762,163.762,0,0,0-16.5-7.452c-9.794-3.751-20.458-6.552-31.039-5.614-9.714.864-20.083,5.749-23.928,15.248-3.506,8.666-1.2,20.372,6.417,26.17C40.554,62,52.39,61.134,59.2,54.609c7.683-7.372,6.211-19.208-.545-26.638-3.547-3.9-8.3-7.056-13.757-6.819a18.552,18.552,0,0,0-12,4.929,19.513,19.513,0,0,0-2.416,24.035,17.7,17.7,0,0,0,26.781,2.892c3.938-3.718,4.719-8.393,3.855-13.561-.817-4.876-2.507-9.205-6.6-12.254-7.986-5.947-19.662-2.226-23.2,6.935-1.7,4.395-1.866,9.945.713,14.043,2.7,4.293,8,6.527,12.915,6.794,4.648.25,9.26-1.238,11.789-5.358,2.372-3.869,2.35-8.889.779-13.044-1.7-4.5-5.435-8.371-10.259-9.351a12.463,12.463,0,0,0-12.714,5.647,12.682,12.682,0,0,0-.707,12.711c2.257,4.045,6.376,5.735,10.432,7.488,2.251.974,4.865,2.047,5.933,4.422,1.4,3.1-.151,6.027-2.854,7.7-1.915,1.183-6.726,3.674-4.188,6.594,1.117,1.288,3.085,1.58,4.516,2.394a3.034,3.034,0,0,1,1.56,3.894,3.244,3.244,0,0,1-2.942,2.166c-.239.008-.162.548.091.539",
    transform: "translate(43.772 22.922)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276107",
    "data-name": "Path 276107",
    d: "M159.818,38.08a6.172,6.172,0,0,0,2,3.5,7.122,7.122,0,0,0,3.641,1.5c3.066.421,7-.22,8.762-3.027a11.563,11.563,0,0,0,1.436-5.366,18.466,18.466,0,0,0-.476-5.468,18.264,18.264,0,0,0-5.011-8.905c-3.932-3.781-10.311-6.66-15.766-4.791A10.056,10.056,0,0,0,148.216,22a7.7,7.7,0,0,0-.124,4.9,10.161,10.161,0,0,0,2.389,3.726,14.373,14.373,0,0,0,8.157,4.208c3.214.421,6.913-.894,7.981-4.221,1.081-3.363-.352-7.326-2.218-10.141a16.333,16.333,0,0,0-19.362-6.343,16.661,16.661,0,0,0-7.829,6.128c-1.8,2.7-2.6,6.156-1.137,9.191a9.218,9.218,0,0,0,8.261,5.052c3.487.036,7.361-1.7,9.1-4.835a5.85,5.85,0,0,0-2.87-8.058c-3.2-1.566-7.2-.319-9.629,2.091a9.39,9.39,0,0,0-2.713,8.319,8.676,8.676,0,0,0,2.229,4.191c.35.374,1.137.061.713-.394a7.778,7.778,0,0,1-1.676-8.1,9.15,9.15,0,0,1,6.288-5.76,6.453,6.453,0,0,1,4.86.559,5.315,5.315,0,0,1,2.562,3.608c.548,3.385-2.763,6.049-5.619,7.012a8.816,8.816,0,0,1-9.131-1.786,7.668,7.668,0,0,1-1.58-8.352,14.326,14.326,0,0,1,5.908-6.731,15.235,15.235,0,0,1,23.036,9.863,7.621,7.621,0,0,1-.46,4.995,5.769,5.769,0,0,1-3.8,2.771c-2.694.671-5.611-.311-7.892-1.745-2.226-1.4-4.428-3.583-4.887-6.28-.512-2.986,1.216-6.351,3.528-8.176,4.282-3.379,10.322-1.78,14.516.905a17.9,17.9,0,0,1,8.129,15.515,12.6,12.6,0,0,1-.971,4.868,5.829,5.829,0,0,1-3.927,3.162c-2.463.691-5.74.76-7.887-.839a6.2,6.2,0,0,1-2.149-3.311c-.058-.2-.226-.063-.19.094",
    transform: "translate(237.057 22.959)",
    fill: "#363636"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5MentalDashboard);
export default __webpack_public_path__ + "static/media/5_Mental__Dashboard.a19867f796db2f706f0c9d1f25de292c.svg";
export { ForwardRef as ReactComponent };